<template>
	<div>
		<modal :name="modal_edit_product_type" transition="nice-modal-fade"  class="final-modal">
			<div class="v-modal-content">
				<div class="v-modal-header">
					<span class="v-modal-dialog-title v-modal-title">Edit {{productType_name}}</span>
				</div>
				<div class="v-modal-body pr-0" style="overflow-y: auto;max-height: 400px;overflow-x: hidden;">
					<div class="pt-3 pr-3" :class="{'overflow_init':overflow_modal == true}">
						<div class="row first-middle-input">
							<div class="col-md-3 col-lg-3 col-sm-3" style="text-align: center;margin-top:30px;">
								<span class style="text-align:center;">
									<img v-if="edit_productByType.image_url" :src="edit_productByType.image_url" style="width:90px!important;height:90px!important;"/>
									<img v-else :src="imgDataUrl" style="width: 90px!important;height:90px!important;"/>
								</span>
								<upload-picture @uploadImage="uploadImage"></upload-picture>
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-12 px-5">
								<div class="grey-bg">
									<div class="mdicon-card">
										<div class="mdicon-card-content">
											<div class="iconimage-grid">
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/beverages.png'}" @click="uploadSelectedIcon('bevarage')">
													<div class="px-3 py-3 pointerImg">
														<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/beverages.png" alt="Beverages">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/clothing.png'}" @click="uploadSelectedIcon('clothing')">
													<div class="px-3 py-3 pointerImg">
														<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/clothing.png" alt="Clothing">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/food.png'}" @click="uploadSelectedIcon('food')">
													<div class="px-3 py-3 pointerImg">
														<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/food.png" alt="Food">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/smokes.png'}" @click="uploadSelectedIcon('smokes')">
													<div class="px-3 py-3 pointerImg">
														<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/smokes.png" alt="Smokes">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/apparel.png'}" @click="uploadSelectedIcon('apparel')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/apparel.png" alt="Apparel">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/tobacco.png'}" @click="uploadSelectedIcon('tobacco')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/tobacco.png" alt="Tobacco">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/sunglasses.png'}" @click="uploadSelectedIcon('sunglasses')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/sunglasses.png" alt="Sunglasses">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/watches.png'}" @click="uploadSelectedIcon('watches')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/watches.png" alt="Watches">
													</div>
												</div>

												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/consumer_goods.png'}" @click="uploadSelectedIcon('goods')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/consumer_goods.png" alt="Goods">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/ingredients.png'}" @click="uploadSelectedIcon('ingredients')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/ingredients.png" alt="Ingredients">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/skin_care.png'}" @click="uploadSelectedIcon('skincare')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/skin_care.png" alt="SkinCare">
													</div>
												</div>
														
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/wellness.png'}" @click="uploadSelectedIcon('wellness')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/wellness.png" alt="Wellness">
													</div>
												</div>
												<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/massages.png'}" @click="uploadSelectedIcon('massages')">
													<div class="px-3 py-3 pointerImg">
														<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/massages.png" alt="Massages">
													</div>
												</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/hygiene.png'}" @click="uploadSelectedIcon('hygiene')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/hygiene.png" alt="Hygiene">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/sports_massage.png'}" @click="uploadSelectedIcon('sports_massage')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/sports_massage.png" alt="Sports Massage">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/thai_massage.png'}" @click="uploadSelectedIcon('thai_massage')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/thai_massage.png" alt="Thai Massage">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_massage.png'}" @click="uploadSelectedIcon('body_massage')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_massage.png" alt="Body Massage">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/shoulder_massage.png'}" @click="uploadSelectedIcon('shoulder_massage')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/shoulder_massage.png" alt="Shoulder Massage">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/foot_massage.png'}" @click="uploadSelectedIcon('foot_massage')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/foot_massage.png" alt="Foot Massage">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/head_massage.png'}" @click="uploadSelectedIcon('head_massage')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/head_massage.png" alt="Head Massage">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_scrubs.png'}" @click="uploadSelectedIcon('body_scrubs')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_scrubs.png" alt="Body Scrubs">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_masques.png'}" @click="uploadSelectedIcon('body_masques')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_masques.png" alt="Body Masques">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/face_refreshers.png'}" @click="uploadSelectedIcon('face_refreshers')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/face_refreshers.png" alt="Face Refreshers">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/manicure.png'}" @click="uploadSelectedIcon('manicure')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/manicure.png" alt="Manicure">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/pedicure.png'}" @click="uploadSelectedIcon('pedicure')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/pedicure.png" alt="pedicure">
														</div>
													</div>

													<!-- Product Types -->
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/cakes.png'}" @click="uploadSelectedIcon('cakes')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/cakes.png" alt="Cakes">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/cheese_plate.png'}" @click="uploadSelectedIcon('cheese_plate')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/cheese_plate.png" alt="Cheese Plate">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/coffee.png'}" @click="uploadSelectedIcon('coffee')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/coffee.png" alt="Coffee">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/fruits.png'}" @click="uploadSelectedIcon('fruits')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/fruits.png" alt="Fruits">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/gin.png'}" @click="uploadSelectedIcon('gin')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/gin.png" alt="Gin">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/ice_cream.png'}" @click="uploadSelectedIcon('ice_cream')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/ice_cream.png" alt="Ice Cream">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/other_soft_drinks.png'}" @click="uploadSelectedIcon('other_soft_drinks')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/other_soft_drinks.png" alt="Other Soft Drinks">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/other_spirits.png'}" @click="uploadSelectedIcon('other_spirits')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/other_spirits.png" alt="Other Spirits">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/others_appetizers.png'}" @click="uploadSelectedIcon('others_appetizers')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/others_appetizers.png" alt="Others Appetizers">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/red_wine.png'}" @click="uploadSelectedIcon('red_wine')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/red_wine.png" alt="Red Wine">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/rose.png'}" @click="uploadSelectedIcon('rose')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/rose.png" alt="Rose">
														</div>
													</div>
																			<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/wraps.png'}" @click="uploadSelectedIcon('Wraps')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/wraps.png" alt="Wraps" style="width: 27px!important;">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/iced_chocolate.png'}" @click="uploadSelectedIcon('Iced Chocolate')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/iced_chocolate.png" alt="Iced Chocolate">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/rum.png'}" @click="uploadSelectedIcon('Rum')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/rum.png" alt="Rum">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/single_malt_whisky.png'}" @click="uploadSelectedIcon('Single malt Whiskey')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/single_malt_whisky.png" alt="Single malt Whiskey">
														</div>
													</div>
													<!-- <div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/tequila.png'}" @click="uploadSelectedIcon('Tequila')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/tequila.png" alt="Tequila">
														</div>
													</div> -->
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/hot_chocolate.png'}" @click="uploadSelectedIcon('Hot Chocolate')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/hot_chocolate.png" alt="Hot Chocolate">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/liquer.png'}" @click="uploadSelectedIcon('Liquer')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/liquer.png" alt="Liquer">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/sandwiches.png'}" @click="uploadSelectedIcon('Sandwiches')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/sandwiches.png" alt="Sandwiches" style="width: 28px!important;">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/salad.png'}" @click="uploadSelectedIcon('salad')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/salad.png" alt="Salad">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/soda.png'}" @click="uploadSelectedIcon('soda')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/soda.png" alt="Soda">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/soup.png'}" @click="uploadSelectedIcon('soup')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/soup.png" alt="Soup">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/tea.png'}" @click="uploadSelectedIcon('tea')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/tea.png" alt="Tea">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/tequila.png'}" @click="uploadSelectedIcon('tequila')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/tequila.png" alt="Tequila">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/vodka.png'}" @click="uploadSelectedIcon('vodka')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/vodka.png" alt="Vodka">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/water.png'}" @click="uploadSelectedIcon('water')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/water.png" alt="Water">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/whisky.png'}" @click="uploadSelectedIcon('whisky')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/whisky.png" alt="Whisky">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/white_wine.png'}" @click="uploadSelectedIcon('white_wine')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/white_wine.png" alt="White Wine">
														</div>
													</div>

													<!-- Sub-Categories -->
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/appetizers.png'}" @click="uploadSelectedIcon('appetizers')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/appetizers.png" alt="Appetizers">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/beer.png'}" @click="uploadSelectedIcon('beer')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/beer.png" alt="Beer">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/brunch.png'}" @click="uploadSelectedIcon('brunch')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/brunch.png" alt="Brunch">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/burger.png'}" @click="uploadSelectedIcon('burger')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/burger.png" alt="Burger">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/champange.png'}" @click="uploadSelectedIcon('champange')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/champange.png" alt="Champange">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cigarettes.png'}" @click="uploadSelectedIcon('cigarettes')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cigarettes.png" alt="Cigarettes">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cigars.png'}" @click="uploadSelectedIcon('cigars')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cigars.png" alt="Cigars">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cocktails.png'}" @click="uploadSelectedIcon('cocktails')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cocktails.png" alt="Cocktails">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/desserts.png'}" @click="uploadSelectedIcon('desserts')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/desserts.png" alt="Desserts">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/entrees.png'}" @click="uploadSelectedIcon('entrees')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/entrees.png" alt="Entrees">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/hats.png'}" @click="uploadSelectedIcon('hats')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/hats.png" alt="Hats">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/pastas.png'}" @click="uploadSelectedIcon('pastas')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/pastas.png" alt="Pastas">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/pizzas.png'}" @click="uploadSelectedIcon('pizzas')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/pizzas.png" alt="Pizzas">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/shoes.png'}" @click="uploadSelectedIcon('shoes')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/shoes.png" alt="Shoes">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/soft_drinks.png'}" @click="uploadSelectedIcon('soft_drinks')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/soft_drinks.png" alt="Soft Drinks">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/app_specials.png'}" @click="uploadSelectedIcon('app_specials')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/app_specials.png" alt="Appetizers Specials">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/spirits.png'}" @click="uploadSelectedIcon('spirits')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/spirits.png" alt="Spirits">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/wine.png'}" @click="uploadSelectedIcon('wine')">
														<div class="px-3 py-3 pointerImg">
															<img class="width31" src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/wine.png" alt="Wine">
														</div>
													</div>

													<!-- Latest Images -->
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/casual_shoe.png'}" @click="uploadSelectedIcon('casual_shoe')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/casual_shoe.png" alt="casual_shoe">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/cheese.png'}" @click="uploadSelectedIcon('cheese')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/cheese.png" alt="cheese">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/cuban_hat.png'}" @click="uploadSelectedIcon('cuban_hat')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/cuban_hat.png" alt="cuban_hat">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/dress_shoe.png'}" @click="uploadSelectedIcon('dress_shoe')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/dress_shoe.png" alt="dress_shoe">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/entry_fee.png'}" @click="uploadSelectedIcon('entry_fee')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/entry_fee.png" alt="entry_fee">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/fedora.png'}" @click="uploadSelectedIcon('fedora')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/fedora.png" alt="fedora">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_bar.png'}" @click="uploadSelectedIcon('ice_cream_bar')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_bar.png" alt="ice_cream_bar">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_cone.png'}" @click="uploadSelectedIcon('ice_cream_cone')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_cone.png" alt="ice_cream_cone">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_cup.png'}" @click="uploadSelectedIcon('ice_cream_cup')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_cup.png" alt="ice_cream_cup">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_float.png'}" @click="uploadSelectedIcon('ice_cream_float')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_float.png" alt="ice_cream_float">
														</div>
													</div>
													<div class="text-center bordertransparent" :class="{'selectedicon':edit_productByType.image_url=='https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/sneakers.png'}" @click="uploadSelectedIcon('sneakers')">
														<div class="px-3 py-3 pointerImg">
															<img src="https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/sneakers.png" alt="sneakers">
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
						</div>
						<div class="preview-elements pb-2">
							<form>
								<div class="form-group mt-0 contactGroup">
								<input
									class="inputContact"
									v-validate="'required'"
									type="text"
									name="productTypeName"
									autofocus
									v-model="edit_productByType.name"
									required
									:maxlength="producttypename"
									id="edit_proc_type_name"
								/>
								<span class="highlightContact"></span>
								<span class="barContact"></span>
								<label class="labelContact">
									Product Type Name
									<sup>★</sup>
								</label>
								<span
									class="invalid-feedback-form"
									v-show="errors.has('productTypeName')"
									style="display:inline;"
								>{{ errors.first('productTypeName') }}</span>
								<p
									class="pull-right text-right text-grey font-600 fs-12 pt-1"
								>{{producttypename - edit_productByType.name.length}} / {{producttypename}}</p>
								</div>
								<div class="row mt-8 ml-0 mr-0">
								<div class="col-md-6" style="padding-left:0px!important;">
									<div class="form-group contactGroup" style="margin-top: 0px;">
									<label class="text-secondary" style="font-size: 14px;margin-bottom: 0px;">
										Category
										<sup>★</sup>
									</label>
									<multiselect
										v-model="selectedCategory"
										class="digi-multiselect"
										id="ajax"
										label="category_name"
										placeholder="Select Category"
										:options="allCategories"
										:multiple="false"
										:searchable="true"
										:loading="isLoading"
										:internal-search="false"
										:clear-on-select="false"
										:close-on-select="true"
										:max-height="200"
										:show-no-results="true"
										:hide-selected="false"
										@search-change="loadCategorySearch"
										@select="checksubcategory"
										@open="detectOpen"
										@close="detectClose"
										open-direction="top"
										v-validate="'required'"
										name="category"
									>
										<template slot="tag" slot-scope="{ option, remove }">
											<span class="custom__tag">
												<span>{{ option.category_name }}</span>
												<span class="custom__remove" @click="remove(option)">❌</span>
											</span>
										</template>
										<template slot="afterList">
											<div v-observe-visibility="reachedEndOfList" />
										</template>
										<span
										slot="noResult"
										class="font-weight-bold text-center d-block"
										>No Results Found.</span>
									</multiselect>
									<span
										class="invalid-feedback-form"
										v-show="errors.has('category')"
										style="display:inline;"
									>Please Select Category</span>
									</div>
								</div>
								<div class="col-md-6" style="padding-right:0px!important;">
									<div class="form-group contactGroup" style="margin-top: 0px;">
									<label class="text-secondary" style="font-size: 14px;margin-bottom: 0px;">
										Sub Category
										<sup>★</sup>
									</label>
									<multiselect class="digi-multiselect" v-if="selectedCategory == ''" :options="optionsEmpty" placeholder="Select Sub Category"> 		
										<template slot="noOptions">Please Select Category</template>
									</multiselect>
									<multiselect v-else
											v-model="selectedSubCategory"
											class="digi-multiselect"													
											id="ajax1"
											label="sub_category_name"
											placeholder="Select Sub Category"
											:options="allSubCategories"
											:multiple="false"
											:searchable="true"
											:loading="isLoading"
											:internal-search="false"
											:clear-on-select="false"				
											:close-on-select="true"
											open-direction="top"
											:options-limit="40"
											:max-height="200"
											:show-no-results="true"
											:hide-selected="false"
											@search-change="loadSubCategorySearch"
											v-validate="'required'"
											name="subcategory"
										>
											<template slot="tag" slot-scope="{ option, remove }">
												<span class="custom__tag">
													<span>{{ option.sub_category_name}}</span>
													<span class="custom__remove" @click="remove(option)">❌</span>
												</span>
											</template>
											<template slot="afterList">
												<div v-observe-visibility="reachedEndOfListSubcategory" v-if="allSubCategories.length >= 10" />
											</template>
											<span
											slot="noResult"
											class="font-weight-bold text-center d-block"
											>No Results Found.</span>
										</multiselect>
									<span
										class="invalid-feedback-form"
										v-show="errors.has('subcategory')"
										style="display:inline;"
									>Please Select Sub Category</span>
									</div>
								</div>
								</div>
								<div class="form-group contactGroup" style="padding-left: 2px;">
								<textarea
									class="inputContact mt-2"
									type="text"
									v-model="edit_productByType.description"
									:maxlength="description"
									required
									id="edit_proc_type_desc"
								></textarea>
								<span class="highlightContact"></span>
								<label class="labelContact">Description</label>
								<p
									class="pull-right text-right text-grey font-600 fs-12 pt-1"
								>{{description - edit_productByType.description.length}} / {{description}}</p>
								</div>
							</form>
						</div>
					</div>					
				</div>
				<div class="v-modal-dialog-actions modal-bg text-center pt-5 pb-5">
					<a class="btn btn-link btn-smm" @click="cancelEditProductType">CANCEL</a>
					<button class="btn btn-secondary btn-smm text-uppercase" @click="save">SAVE</button>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
import UploadPicture from './UploadPicture'
import ProductTypeService from './mixins/productTye'
import { EventBus } from './eventBus/nav-bar-event.js'
export default {
    props: ['modal_edit_product_type', 'productTypeById', 'source'],
    mixins: [ProductTypeService],
    data() {
        return {
            imgDataUrl: 'https://cdn.digicollect.com/cdn/pos/images-new-theme/defaultUserPicture.svg', // the datebase64 url of created image,
            edit_productByType: {
                name: '',
                description: '',
                image_url: '',
                category_id: '',
				sub_category_id: '',
				product_type_id:''
            },
            status: false,
            allCategories:[],
			temp_allCategories:[],
			allSubCategories:[],
			temp_allSubCategories:[],
            searchdata: '',
            producttypename: 45,
            description: 1000,
            selectedCategory: {},
            selectedSubCategory: {},
            ajaxCallInProgress: false,
			productType_name:'',
			isLoading: false,
			isVisible: false,
			isLoadingSubCategory:false,
			count: 0,
			limit: 10,
			total: 0,
			scrollable: false,
			scrollableSubCategory:false,
			overflow_modal: false,
			optionsEmpty:[]
        }
    },
    methods: {
		detectOpen(){
			this.overflow_modal = true
		},
		detectClose(){
			this.overflow_modal = false
		},
		async loadCategorySearch(searchdata) {
			this.isLoading = true			
			let response = await this.$http.post('/categories/get_all_categories_for_sub_category', {
				searchdata: searchdata,	
				skip: 0,			
				limit:10
			})
			this.allCategories = response.data.response.category_type_list
			this.count = this.allCategories.length
			this.isLoading = false
			this.scrollable = false
		},
		async reachedEndOfList(reached) {
			this.isVisible = reached
			if (reached) {
				if (this.scrollable == false) {
					this.isLoading = true					
					let response = await this.$http.post('/categories/get_all_categories_for_sub_category', {
						searchdata: this.searchdata,	
						skip: this.count,			
						limit:10
					})
					this.temp_allCategories = response.data.response.category_type_list.length;
					if (response.data.response.skip == this.count) {
						if (this.temp_allCategories > 0) {
							let tempFiles = response.data.response.category_type_list;	
							tempFiles.forEach(el => {
								this.allCategories.push(el);
							});
							this.count += response.data.response.category_type_list.length;	
							this.isLoading = false
						} else {
							this.scrollable = true
							this.isLoading = false
						}
					}
					this.isLoading = false
				}
			}
		},
		async loadSubCategorySearch(searchdata) {
			this.isLoadingSubCategory = true	
			let response = await this.$http.post('/categories/get_sub_category_for_category', {
				searchdata: searchdata,	
				skip: 0,			
				limit:10,
				category_id: this.edit_productByType.category_id
			})
			this.allSubCategories = response.data.response.sub_category_list
			this.count = this.allSubCategories.length
			this.isLoadingSubCategory = false
			this.scrollableSubCategory = false
		},
		async reachedEndOfListSubcategory(reached) {			
			this.isVisible = reached
			if (reached) {
				if (this.scrollableSubCategory == false) {
					this.isLoadingSubCategory = true					
					let response = await this.$http.post('/categories/get_sub_category_for_category', {
						searchdata: this.searchdata,	
						skip: this.count,			
						limit:10,
						category_id: this.edit_productByType.category_id
					})
                    this.temp_allSubCategories = response.data.response.sub_category_list.length;
					if (response.data.response.skip == this.count) {
						if (this.temp_allSubCategories > 0) {
							let tempFiles = response.data.response.sub_category_list;	
							tempFiles.forEach(el => {
								this.allSubCategories.push(el);
							});
							this.count += response.data.response.sub_category_list.length;	
							this.isLoading = false
						} else {
							this.scrollableSubCategory = true
							this.isLoading = false
						}
					}
					this.isLoading = false
				}
			}
		},
		async loadCategories(searchdata) {
			this.isLoading = true
			let response = await this.$http.post('/categories/get_all_categories_for_sub_category', {
				searchdata: searchdata,	
				skip: 0,			
				limit:10
            })			
			this.count = 0
			this.allCategories = response.data.response.category_type_list
			this.temp_allCategories= response.data.response.category_type_list
			this.isLoading = false
		},
		async loadSubCategories(searchdata) {
			this.isLoadingSubCategory = true
			let response = await this.$http.post('/categories/get_sub_category_for_category', {
				searchdata: searchdata,	
				skip: 0,			
				limit:10,
				category_id: this.edit_productByType.category_id
			})
			this.count = 0
			this.allSubCategories = response.data.response.sub_category_list
			this.temp_allSubCategories = response.data.response.sub_category_list
			this.isLoadingSubCategory = false
		},
        showEditProductType() {
            this.$modal.show('edit-product-type')
        },
        cancelEditProductType() {
			this.edit_productByType = {
                name: '',
                description: '',
                image_url: '',
                category_id: '',
                sub_category_id: ''
			}
			this.selectedCategory = {}
			this.selectedSubCategory = {}
			this.$emit('editCancelpt')
            this.$modal.hide('edit-product-type')
        },
        uploadImage(imgData) {
            this.edit_productByType.image_url = imgData
        },
        save() {
            this.$validator.validate().then(result => {
                if (result) {					
					let details = {
						name:this.edit_productByType.name,
						description: this.edit_productByType.description,
						image_url: this.edit_productByType.image_url,
						category_id: this.edit_productByType.category_id,
						category_name: this.edit_productByType.category_name,
						sub_category_id: this.edit_productByType.sub_category_id,
						product_type_id:this.edit_productByType.product_type_id,
						sub_category_name: this.edit_productByType.sub_category_name,
						status:this.edit_productByType.status
					}
                    this.updateProductType(details)
                } else {
                }
            })
        },
		checksubcategory(){
			this.selectedSubCategory = null
			this.allSubCategories = []
			this.temp_allSubCategories = []	
			this.edit_productByType.sub_category_id = null
			this.edit_productByType.sub_category_name = null
			setTimeout(() => {
				this.loadSubCategories()				
			}, 100);
		},
        uploadSelectedIcon(obj){
			if(obj == 'bevarage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/beverages.png'
			}
			else if(obj == 'clothing'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/clothing.png'
			}
			else if(obj == 'food'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/food.png'
			}
			else if(obj == 'smokes'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/smokes.png'
			}

			else if(obj == 'cakes'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/cakes.png'
			}
			else if(obj == 'cheese_plate'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/cheese_plate.png'
			}
			else if(obj == 'coffee'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/coffee.png'
			}
			else if(obj == 'fruits'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/fruits.png'
			}
			else if(obj == 'gin'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/gin.png'
			}
			else if(obj == 'ice_cream'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/ice_cream.png'
			}
			else if(obj == 'other_soft_drinks'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/other_soft_drinks.png'
			}
			else if(obj == 'other_spirits'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/other_spirits.png'
			}
			else if(obj == 'others_appetizers'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/others_appetizers.png'
			}
			else if(obj == 'red_wine'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/red_wine.png'
			}
			else if(obj == 'rose'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/rose.png'
			}
			else if(obj == 'Rum'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/rum.png'
			}
			else if(obj == 'Tequila'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/tequila.png'
			}
			else if(obj == 'Wraps'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/wraps.png'
			}
			else if(obj == 'Iced Chocolate'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/iced_chocolate.png'
			}
			else if(obj == 'Single malt Whiskey'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/single_malt_whisky.png'
			}
			else if(obj == 'Hot Chocolate'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/hot_chocolate.png'
			}
			else if(obj == 'Liquer'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/liquer.png'
			}
			else if(obj == 'Sandwiches'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/sandwiches.png'
			}
			else if(obj == 'salad'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/salad.png'
			}
			else if(obj == 'soda'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/soda.png'
			}
			else if(obj == 'soup'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/soup.png'
			}
			else if(obj == 'tea'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/tea.png'
			}
			// else if(obj == 'tequila'){
			//     this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/tequila.png'
			// }
			else if(obj == 'vodka'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/vodka.png'
			}
			else if(obj == 'water'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/water.png'
			}
			else if(obj == 'whisky'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/whisky.png'
			}
			else if(obj == 'white_wine'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/white_wine.png'
			}
			
			else if(obj == 'skincare'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/skin_care.png'
			}
			
			else if(obj == 'wellness'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/wellness.png'
			}
			else if(obj == 'massages'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/massages.png'
			}
			else if(obj == 'hygiene'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/hygiene.png'
			}
			else if(obj == 'sports_massage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/sports_massage.png'
			}
			else if(obj == 'thai_massage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/thai_massage.png'
			}
			else if(obj == 'body_massage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_massage.png'
			}
			else if(obj == 'shoulder_massage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/shoulder_massage.png'
			}
			else if(obj == 'foot_massage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/foot_massage.png'
			}
			else if(obj == 'head_massage'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/head_massage.png'
			}
			else if(obj == 'body_scrubs'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_scrubs.png'
			}
			else if(obj == 'body_masques'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/body_masques.png'
			}
			else if(obj == 'face_refreshers'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/face_refreshers.png'
			}
			else if(obj == 'manicure'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/manicure.png'
			}
			else if(obj == 'pedicure'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/product_types/pedicure.png'
			}
                

			else if(obj == 'appetizers'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/appetizers.png'
			}
			else if(obj == 'beer'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/beer.png'
			}
			else if(obj == 'brunch'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/brunch.png'
			}
			else if(obj == 'burger'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/burger.png'
			}
			else if(obj == 'champange'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/champange.png'
			}
			else if(obj == 'cigarettes'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cigarettes.png'
			}
			else if(obj == 'cigars'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cigars.png'
			}
			else if(obj == 'cocktails'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/cocktails.png'
			}
			else if(obj == 'desserts'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/desserts.png'
			}
			else if(obj == 'entrees'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/entrees.png'
			}
			else if(obj == 'hats'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/hats.png'
			}
			else if(obj == 'pastas'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/pastas.png'
			}
			else if(obj == 'pizzas'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/pizzas.png'
			}
			else if(obj == 'shoes'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/shoes.png'
			}
			else if(obj == 'soft_drinks'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/soft_drinks.png'
			}
			else if(obj == 'app_specials'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/app_specials.png'
			}
			else if(obj == 'spirits'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/spirits.png'
			}
			else if(obj == 'wine'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/wine.png'
			}

			else if(obj == 'apparel'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/apparel.png'
			}
			else if(obj == 'tobacco'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/tobacco.png'
			}
			else if(obj == 'sunglasses'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/sunglasses.png'
			}
			else if(obj == 'watches'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/watches.png'
			}
			else if(obj == 'goods'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/consumer_goods.png'
			}
			else if(obj == 'ingredients'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/ingredients.png'
			}
			else if(obj == 'skincare'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/sub_categories/skin_care.png'
			}
				
			else if(obj == 'casual_shoe'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/casual_shoe.png'
			}
			else if(obj == 'cheese'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/cheese.png'
			}
			else if(obj == 'cuban_hat'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/cuban_hat.png'
			}
			else if(obj == 'dress_shoe'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/dress_shoe.png'
			}
			else if(obj == 'entry_fee'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/entry_fee.png'
			}
			else if(obj == 'fedora'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/fedora.png'
			}
			else if(obj == 'ice_cream_bar'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_bar.png'
			}
			else if(obj == 'ice_cream_cone'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_cone.png'
			}
			else if(obj == 'ice_cream_cup'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_cup.png'
			}
			else if(obj == 'ice_cream_float'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/ice_cream_float.png'
			}
			else if(obj == 'sneakers'){
				this.edit_productByType.image_url = 'https://cdn.digicollect.com/cdn/pos/pos_inventory_default_icons/categories/sneakers.png'
			}
		},
    },
    components: {
        UploadPicture
    },
    created() {
        const dict = {
            custom: {
                productTypeName: {
                	required: () => 'Product Type Name is Required'
                }
            }
        }
        this.$validator.localize('en', dict)
    },
    mounted(){
        EventBus.$on('detailsProductTypeById',productTypeById=>{
            this.$http.post('/products/get_product_type_by_id', {
                product_type_id: productTypeById
            })
            .then(response => {
                if (response.data.status_id == 1) {
                    this.selectedCategory = {
                        category_name: response.data.response.details.category_name,
                        category_id: response.data.response.details.category_id
                    }
                    this.edit_productByType = response.data.response.details
                    this.productType_name = response.data.response.details.name
                    this.selectedSubCategory = {
                        sub_category_name:response.data.response.details.sub_category_name,
                        sub_category_id: response.data.response.details.sub_category_id
                    }
                }
            })
            .then(response => {
                this.loadCategories()
                this.loadSubCategories()
            })
		}),
		EventBus.$on('editProductTypeBySb',productTypeById=>{			
			if(this.source == "fromCategory"){				
				this.$http.post('/products/get_product_type_by_id', {
					product_type_id: productTypeById
				})
				.then(response => {
					if (response.data.status_id == 1) {
						this.selectedCategory = {
							category_name: response.data.response.details.category_name,
							category_id: response.data.response.details.category_id
						}
						this.edit_productByType = response.data.response.details
						this.productType_name = response.data.response.details.name
						this.selectedSubCategory = {
							sub_category_name:response.data.response.details.sub_category_name,
							sub_category_id: response.data.response.details.sub_category_id
						}
					}
				})
				.then(response => {
					this.loadCategories()
					this.loadSubCategories()
				})
			}            
        })
	},
	watch:{
		'selectedCategory'(newValue,oldValue){
			if(newValue){				
				this.edit_productByType.category_id = this.selectedCategory.category_id
				this.edit_productByType.category_name = this.selectedCategory.category_name
			}
		},
		'selectedSubCategory'(newValue,oldValue){
			if(newValue){				
				this.edit_productByType.sub_category_id = this.selectedSubCategory.sub_category_id
				this.edit_productByType.sub_category_name = this.selectedSubCategory.sub_category_name
			}
		}
	}
}
</script>
<style scoped>
.overflow_init{
	overflow: initial !important;
}
.modalHeight {
  height: 250px !important;
}
.v-modal-layout {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
}
.grey-bg {
    border-radius: 10px;
    border: solid 1px #00448b;
    background-color: #cdd2da;
    padding: 5px 10px;
    height: 200px;
    overflow-y: auto;
}
.mdicon-card+.mdicon-card {
    margin-top: 25px;
}
.mdicon-card .mdicon-card-content {
    padding: 10px 5px;
}
.bordertransparent {
	border: 1px solid transparent;
	border-radius: 6px;
	cursor: pointer;
}
.bordertransparent.selectedicon {
	border: 1px solid #00448b;
}
.pointerImg img {
    width: 34px !important;
}
/*! UIkit 2.27.5 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */

.iconimage-img-preserve,
.iconimage-img-preserve audio,
.iconimage-img-preserve canvas,
.iconimage-img-preserve img,
.iconimage-img-preserve svg,
.iconimage-img-preserve video {
	max-width: none
}
@media screen and (max-width: 400px) {
	@-ms-viewport{width:device-width}}.iconimage-grid{display:-ms-flexbox;display:-webkit-flex;display:flex;-ms-flex-wrap:wrap;-webkit-flex-wrap:wrap;flex-wrap:wrap;margin:0;padding:0;list-style:none}.iconimage-grid:after,.iconimage-grid:before{content:"";display:block;overflow:hidden}.iconimage-grid:after{clear:both}.iconimage-grid>*{-ms-flex:none;-webkit-flex:none;flex:none;margin:0;float:left}
    /* .iconimage-grid>*>:last-child{margin-bottom:0}.iconimage-grid{margin-left:-25px}.iconimage-grid>*{padding-left:25px} */
    .iconimage-grid+.iconimage-grid,.iconimage-grid-margin,.iconimage-grid>*>.iconimage-panel+.iconimage-panel{margin-top:25px}@media (min-width:1220px) {
		/* .iconimage-grid {
			margin-left: -35px
		}
		.iconimage-grid>* {
			padding-left: 35px
		} */
		.iconimage-grid+.iconimage-grid,
		.iconimage-grid-margin,
		.iconimage-grid>*>.iconimage-panel+.iconimage-panel {
			margin-top: 35px
		}
	}
	.iconimage-grid-collapse {
		margin-left: 0
	}
	.iconimage-grid-collapse>* {
		padding-left: 0
	}
	.iconimage-grid-collapse+.iconimage-grid-collapse,
	.iconimage-grid-collapse>*>.iconimage-panel+.iconimage-panel,
	.iconimage-grid-collapse>.iconimage-grid-margin {
		margin-top: 0
	}
	.iconimage-grid-small {
		margin-left: -10px
	}
	.iconimage-grid-small>* {
		padding-left: 10px
	}
	.iconimage-grid-small+.iconimage-grid-small,
	.iconimage-grid-small>*>.iconimage-panel+.iconimage-panel,
	.iconimage-grid-small>.iconimage-grid-margin {
		margin-top: 10px
	}
	.iconimage-grid-medium {
		margin-left: -25px
	}
	.iconimage-grid-medium>* {
		padding-left: 25px
	}
	.iconimage-grid-medium+.iconimage-grid-medium,
	.iconimage-grid-medium>*>.iconimage-panel+.iconimage-panel,
	.iconimage-grid-medium>.iconimage-grid-margin {
		margin-top: 25px
	}
	@media (min-width: 960px) {
		.iconimage-grid-large {
			margin-left: -35px
		}
		.iconimage-grid-large>* {
			padding-left: 35px
		}
		.iconimage-grid-large+.iconimage-grid-large,
		.iconimage-grid-large-margin,
		.iconimage-grid-large>*>.iconimage-panel+.iconimage-panel {
			margin-top: 35px
		}
	}
	@media (min-width: 1220px) {
		.iconimage-grid-large {
			margin-left: -50px
		}
		.iconimage-grid-large>* {
			padding-left: 50px
		}
		.iconimage-grid-large+.iconimage-grid-large,
		.iconimage-grid-large-margin,
		.iconimage-grid-large>*>.iconimage-panel+.iconimage-panel {
			margin-top: 50px
		}
	}
	.iconimage-grid-divider:not(:empty) {
		margin-left: -25px;
		margin-right: -25px
	}
	.iconimage-grid-divider>* {
		padding-left: 25px;
		padding-right: 25px
	}
	.iconimage-grid-divider>[class*=iconimage-width-9-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-1-]:not(.iconimage-width-1-1):nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-2-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-3-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-4-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-5-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-6-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-7-]:nth-child(n+2),
	.iconimage-grid-divider>[class*=iconimage-width-8-]:nth-child(n+2) {
		border-left: 1px solid #ddd
	}
	.iconimage-grid-divider:empty {
		margin-top: 25px;
		margin-bottom: 25px;
		border-top: 1px solid #ddd
	}
	.iconimage-grid-match>* {
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-ms-flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap
	}
	.iconimage-grid-match>*>* {
		-ms-flex: none;
		-webkit-flex: none;
		flex: none;
		box-sizing: border-box;
		width: 100%
	}
	[class*=iconimage-grid-width]>* {
		box-sizing: border-box;
		width: 100%
	}
	.iconimage-grid-width-1-2>* {
		width: 50%
	}
	.iconimage-grid-width-1-3>* {
		width: 33.333%
	}
	.iconimage-grid-width-1-4>* {
		width: 25%
	}
	.iconimage-grid-width-1-5>* {
		width: 20%
	}
	.iconimage-grid-width-1-6>* {
		width: 16.666%
	}
	.iconimage-grid-width-1-10>* {
		width: 10%
	}
	.iconimage-grid-width-auto>* {
		width: auto
	}
	@media (min-width: 480px) {
		.iconimage-grid-width-small-1-1>* {
			width: 100%
		}
		.iconimage-grid-width-small-1-2>* {
			width: 50%
		}
		.iconimage-grid-width-small-1-3>* {
			width: 33.333%
		}
		.iconimage-grid-width-small-1-4>* {
			width: 25%
		}
		.iconimage-grid-width-small-1-5>* {
			width: 20%
		}
		.iconimage-grid-width-small-1-6>* {
			width: 16.666%
		}
		.iconimage-grid-width-small-1-10>* {
			width: 10%
		}
	}
	@media (min-width: 768px) {
		.iconimage-grid-width-medium-1-1>* {
			width: 100%
		}
		.iconimage-grid-width-medium-1-2>* {
			width: 50%
		}
		.iconimage-grid-width-medium-1-3>* {
			width: 33.333%
		}
		.iconimage-grid-width-medium-1-4>* {
			width: 25%
		}
		.iconimage-grid-width-medium-1-5>* {
			width: 20%
		}
		.iconimage-grid-width-medium-1-6>* {
			width: 16.666%
		}
		.iconimage-grid-width-medium-1-10>* {
			width: 10%
		}
	}
	@media (min-width: 960px) {
		.iconimage-grid-width-large-1-1>* {
			width: 100%
		}
		.iconimage-grid-width-large-1-2>* {
			width: 50%
		}
		.iconimage-grid-width-large-1-3>* {
			width: 33.333%
		}
		.iconimage-grid-width-large-1-4>* {
			width: 25%
		}
		.iconimage-grid-width-large-1-5>* {
			width: 20%
		}
		.iconimage-grid-width-large-1-6>* {
			width: 16.666%
		}
		.iconimage-grid-width-large-1-10>* {
			width: 10%
		}
	}
	@media (min-width: 1220px) {
		.iconimage-grid-width-xlarge-1-1>* {
			width: 100%
		}
		.iconimage-grid-width-xlarge-1-2>* {
			width: 50%
		}
		.iconimage-grid-width-xlarge-1-3>* {
			width: 33.333%
		}
		.iconimage-grid-width-xlarge-1-4>* {
			width: 25%
		}
		.iconimage-grid-width-xlarge-1-5>* {
			width: 20%
		}
		.iconimage-grid-width-xlarge-1-6>* {
			width: 16.666%
		}
		.iconimage-grid-width-xlarge-1-10>* {
			width: 10%
		}
	}
	[class*=iconimage-width] {
		box-sizing: border-box;
		width: 100%
	}
	.iconimage-width-1-1 {
		width: 100%
	}
	.iconimage-width-1-2,
	.iconimage-width-2-4,
	.iconimage-width-3-6,
	.iconimage-width-5-10 {
		width: 50%
	}
	.iconimage-width-1-3,
	.iconimage-width-2-6 {
		width: 33.333%
	}
	.iconimage-width-2-3,
	.iconimage-width-4-6 {
		width: 66.666%
	}
	.iconimage-width-1-4 {
		width: 25%
	}
	.iconimage-width-3-4 {
		width: 75%
	}
	.iconimage-width-1-5,
	.iconimage-width-2-10 {
		width: 20%
	}
	.iconimage-width-2-5,
	.iconimage-width-4-10 {
		width: 40%
	}
	.iconimage-width-3-5,
	.iconimage-width-6-10 {
		width: 60%
	}
	.iconimage-width-4-5,
	.iconimage-width-8-10 {
		width: 80%
	}
	.iconimage-width-1-6 {
		width: 16.666%
	}
	.iconimage-width-5-6 {
		width: 83.333%
	}
	.iconimage-width-1-10 {
		width: 10%
	}
	.iconimage-width-3-10 {
		width: 30%
	}
	.iconimage-width-7-10 {
		width: 70%
	}
	.iconimage-width-9-10 {
		width: 90%
	}
	@media (min-width: 480px) {
		.iconimage-width-small-1-1 {
			width: 100%
		}
		.iconimage-width-small-1-2,
		.iconimage-width-small-2-4,
		.iconimage-width-small-3-6,
		.iconimage-width-small-5-10 {
			width: 50%
		}
		.iconimage-width-small-1-3,
		.iconimage-width-small-2-6 {
			width: 33.333%
		}
		.iconimage-width-small-2-3,
		.iconimage-width-small-4-6 {
			width: 66.666%
		}
		.iconimage-width-small-1-4 {
			width: 25%
		}
		.iconimage-width-small-3-4 {
			width: 75%
		}
		.iconimage-width-small-1-5,
		.iconimage-width-small-2-10 {
			width: 20%
		}
		.iconimage-width-small-2-5,
		.iconimage-width-small-4-10 {
			width: 40%
		}
		.iconimage-width-small-3-5,
		.iconimage-width-small-6-10 {
			width: 60%
		}
		.iconimage-width-small-4-5,
		.iconimage-width-small-8-10 {
			width: 80%
		}
		.iconimage-width-small-1-6 {
			width: 16.666%
		}
		.iconimage-width-small-5-6 {
			width: 83.333%
		}
		.iconimage-width-small-1-10 {
			width: 10%
		}
		.iconimage-width-small-3-10 {
			width: 30%
		}
		.iconimage-width-small-7-10 {
			width: 70%
		}
		.iconimage-width-small-9-10 {
			width: 90%
		}
	}
	@media (min-width: 768px) {
		.iconimage-width-medium-1-1 {
			width: 100%
		}
		.iconimage-width-medium-1-2,
		.iconimage-width-medium-2-4,
		.iconimage-width-medium-3-6,
		.iconimage-width-medium-5-10 {
			width: 50%
		}
		.iconimage-width-medium-1-3,
		.iconimage-width-medium-2-6 {
			width: 33.333%
		}
		.iconimage-width-medium-2-3,
		.iconimage-width-medium-4-6 {
			width: 66.666%
		}
		.iconimage-width-medium-1-4 {
			width: 25%
		}
		.iconimage-width-medium-3-4 {
			width: 75%
		}
		.iconimage-width-medium-1-5,
		.iconimage-width-medium-2-10 {
			width: 20%
		}
		.iconimage-width-medium-2-5,
		.iconimage-width-medium-4-10 {
			width: 40%
		}
		.iconimage-width-medium-3-5,
		.iconimage-width-medium-6-10 {
			width: 60%
		}
		.iconimage-width-medium-4-5,
		.iconimage-width-medium-8-10 {
			width: 80%
		}
		.iconimage-width-medium-1-6 {
			width: 16.666%
		}
		.iconimage-width-medium-5-6 {
			width: 83.333%
		}
		.iconimage-width-medium-1-10 {
			width: 10%
		}
		.iconimage-width-medium-3-10 {
			width: 30%
		}
		.iconimage-width-medium-7-10 {
			width: 70%
		}
		.iconimage-width-medium-9-10 {
			width: 90%
		}
	}
	@media (min-width: 960px) {
		.iconimage-width-large-1-1 {
			width: 100%
		}
		.iconimage-width-large-1-2,
		.iconimage-width-large-2-4,
		.iconimage-width-large-3-6,
		.iconimage-width-large-5-10 {
			width: 50%
		}
		.iconimage-width-large-1-3,
		.iconimage-width-large-2-6 {
			width: 33.333%
		}
		.iconimage-width-large-2-3,
		.iconimage-width-large-4-6 {
			width: 66.666%
		}
		.iconimage-width-large-1-4 {
			width: 25%
		}
		.iconimage-width-large-3-4 {
			width: 75%
		}
		.iconimage-width-large-1-5,
		.iconimage-width-large-2-10 {
			width: 20%
		}
		.iconimage-width-large-2-5,
		.iconimage-width-large-4-10 {
			width: 40%
		}
		.iconimage-width-large-3-5,
		.iconimage-width-large-6-10 {
			width: 60%
		}
		.iconimage-width-large-4-5,
		.iconimage-width-large-8-10 {
			width: 80%
		}
		.iconimage-width-large-1-6 {
			width: 16.666%
		}
		.iconimage-width-large-5-6 {
			width: 83.333%
		}
		.iconimage-width-large-1-10 {
			width: 10%
		}
		.iconimage-width-large-3-10 {
			width: 30%
		}
		.iconimage-width-large-7-10 {
			width: 70%
		}
		.iconimage-width-large-9-10 {
			width: 90%
		}
	}
	@media (min-width: 1220px) {
		.iconimage-width-xlarge-1-1 {
			width: 100%
		}
		.iconimage-width-xlarge-1-2,
		.iconimage-width-xlarge-2-4,
		.iconimage-width-xlarge-3-6,
		.iconimage-width-xlarge-5-10 {
			width: 50%
		}
		.iconimage-width-xlarge-1-3,
		.iconimage-width-xlarge-2-6 {
			width: 33.333%
		}
		.iconimage-width-xlarge-2-3,
		.iconimage-width-xlarge-4-6 {
			width: 66.666%
		}
		.iconimage-width-xlarge-1-4 {
			width: 25%
		}
		.iconimage-width-xlarge-3-4 {
			width: 75%
		}
		.iconimage-width-xlarge-1-5,
		.iconimage-width-xlarge-2-10 {
			width: 20%
		}
		.iconimage-width-xlarge-2-5,
		.iconimage-width-xlarge-4-10 {
			width: 40%
		}
		.iconimage-width-xlarge-3-5,
		.iconimage-width-xlarge-6-10 {
			width: 60%
		}
		.iconimage-width-xlarge-4-5,
		.iconimage-width-xlarge-8-10 {
			width: 80%
		}
		.iconimage-width-xlarge-1-6 {
			width: 16.666%
		}
		.iconimage-width-xlarge-5-6 {
			width: 83.333%
		}
		.iconimage-width-xlarge-1-10 {
			width: 10%
		}
		.iconimage-width-xlarge-3-10 {
			width: 30%
		}
		.iconimage-width-xlarge-7-10 {
			width: 70%
		}
		.iconimage-width-xlarge-9-10 {
			width: 90%
		}
	}
	@media (min-width: 768px) {
		[class*=iconimage-push-], [class*=iconimage-pull-] {
			position: relative
		}
		.iconimage-push-1-2,
		.iconimage-push-2-4,
		.iconimage-push-3-6,
		.iconimage-push-5-10 {
			left: 50%
		}
		.iconimage-push-1-3,
		.iconimage-push-2-6 {
			left: 33.333%
		}
		.iconimage-push-2-3,
		.iconimage-push-4-6 {
			left: 66.666%
		}
		.iconimage-push-1-4 {
			left: 25%
		}
		.iconimage-push-3-4 {
			left: 75%
		}
		.iconimage-push-1-5,
		.iconimage-push-2-10 {
			left: 20%
		}
		.iconimage-push-2-5,
		.iconimage-push-4-10 {
			left: 40%
		}
		.iconimage-push-3-5,
		.iconimage-push-6-10 {
			left: 60%
		}
		.iconimage-push-4-5,
		.iconimage-push-8-10 {
			left: 80%
		}
		.iconimage-push-1-6 {
			left: 16.666%
		}
		.iconimage-push-5-6 {
			left: 83.333%
		}
		.iconimage-push-1-10 {
			left: 10%
		}
		.iconimage-push-3-10 {
			left: 30%
		}
		.iconimage-push-7-10 {
			left: 70%
		}
		.iconimage-push-9-10 {
			left: 90%
		}
		.iconimage-pull-1-2,
		.iconimage-pull-2-4,
		.iconimage-pull-3-6,
		.iconimage-pull-5-10 {
			left: -50%
		}
		.iconimage-pull-1-3,
		.iconimage-pull-2-6 {
			left: -33.333%
		}
		.iconimage-pull-2-3,
		.iconimage-pull-4-6 {
			left: -66.666%
		}
		.iconimage-pull-1-4 {
			left: -25%
		}
		.iconimage-pull-3-4 {
			left: -75%
		}
		.iconimage-pull-1-5,
		.iconimage-pull-2-10 {
			left: -20%
		}
		.iconimage-pull-2-5,
		.iconimage-pull-4-10 {
			left: -40%
		}
		.iconimage-pull-3-5,
		.iconimage-pull-6-10 {
			left: -60%
		}
		.iconimage-pull-4-5,
		.iconimage-pull-8-10 {
			left: -80%
		}
		.iconimage-pull-1-6 {
			left: -16.666%
		}
		.iconimage-pull-5-6 {
			left: -83.333%
		}
		.iconimage-pull-1-10 {
			left: -10%
		}
		.iconimage-pull-3-10 {
			left: -30%
		}
		.iconimage-pull-7-10 {
			left: -70%
		}
		.iconimage-pull-9-10 {
			left: -90%
		}
	}
	.iconimage-panel {
		display: block;
		position: relative
	}
	.iconimage-panel,
	.iconimage-panel:hover {
		text-decoration: none
	}
	.iconimage-panel:after,
	.iconimage-panel:before {
		content: "";
		display: table
	}
	.iconimage-panel:after {
		clear: both
	}
	.iconimage-panel>:not(.iconimage-panel-title):last-child {
		margin-bottom: 0
	}
	.iconimage-panel-title {
		margin-top: 0;
		margin-bottom: 15px;
		font-size: 18px;
		line-height: 24px;
		font-weight: 400;
		text-transform: none;
		color: #444
	}
	.iconimage-panel-badge {
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1
	}
	.iconimage-panel-teaser {
		margin-bottom: 15px
	}
	.iconimage-panel-body {
		padding: 15px
	}
	.iconimage-panel-box {
		padding: 15px;
		background: #fafafa;
		color: #444;
		border: 1px solid #ddd;
		border-radius: 4px
	}
	.iconimage-panel-box-hover:hover {
		color: #444
	}
	.iconimage-panel-box .iconimage-panel-title {
		color: #444
	}
	.iconimage-panel-box .iconimage-panel-badge {
		top: 10px;
		right: 10px
	}
	.iconimage-panel-box>.iconimage-panel-teaser {
		margin-top: -16px;
		margin-left: -16px;
		margin-right: -16px
	}
	.iconimage-panel-box>.iconimage-nav-side {
		margin: 0 -15px
	}
	.iconimage-panel-box-primary {
		background-color: #ebf7fd;
		color: #2d7091;
		border-color: rgba(45, 112, 145, .3)
	}
	.iconimage-panel-box-primary-hover:hover {
		color: #2d7091
	}
	.iconimage-panel-box-primary .iconimage-panel-title {
		color: #2d7091
	}
	.iconimage-panel-box-secondary {
		background-color: #fff;
		color: #444
	}
	.iconimage-panel-box-secondary-hover:hover {
		color: #444
	}
	.iconimage-panel-box-secondary .iconimage-panel-title {
		color: #444
	}
	.iconimage-panel-hover {
		padding: 15px;
		color: #444;
		border: 1px solid transparent;
		border-radius: 4px
	}
	.iconimage-panel-hover:hover {
		background: #fafafa;
		color: #444;
		border-color: #ddd
	}
	.iconimage-panel-hover .iconimage-panel-badge {
		top: 10px;
		right: 10px
	}
	.iconimage-panel-hover>.iconimage-panel-teaser {
		margin-top: -16px;
		margin-left: -16px;
		margin-right: -16px
	}
	.iconimage-panel-header .iconimage-panel-title {
		padding-bottom: 10px;
		border-bottom: 1px solid #ddd;
		color: #444
	}
	.iconimage-panel-space {
		padding: 30px
	}
	.iconimage-panel-space .iconimage-panel-badge {
		top: 30px;
		right: 30px
	}
	.iconimage-panel+.iconimage-panel-divider {
		margin-top: 50px!important
	}
	.iconimage-panel+.iconimage-panel-divider:before {
		content: "";
		display: block;
		position: absolute;
		top: -25px;
		left: 0;
		right: 0;
		border-top: 1px solid #ddd
	}
	@media (min-width: 1220px) {
		.iconimage-panel+.iconimage-panel-divider {
			margin-top: 70px!important
		}
		.iconimage-panel+.iconimage-panel-divider:before {
			top: -35px
		}
	}
	.iconimage-panel-box .iconimage-panel-teaser {
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		overflow: hidden;
		-webkit-transform: translateZ(0)
	}
	.iconimage-block {
		position: relative;
		box-sizing: border-box;
		padding-top: 20px;
		padding-bottom: 20px
	}
	@media (min-width: 768px) {
		.iconimage-block {
			padding-top: 50px;
			padding-bottom: 50px
		}
	}
	.iconimage-block:after,
	.iconimage-block:before {
		content: "";
		display: table
	}
	.iconimage-block:after {
		clear: both
	}
	.iconimage-block>:last-child {
		margin-bottom: 0
	}
	.iconimage-block-large {
		padding-top: 20px;
		padding-bottom: 20px
	}
	@media (min-width: 768px) {
		.iconimage-block-large {
			padding-top: 50px;
			padding-bottom: 50px
		}
	}
	@media (min-width: 960px) {
		.iconimage-block-large {
			padding-top: 100px;
			padding-bottom: 100px
		}
	}
	.iconimage-block-default {
		background: #fff
	}
	.iconimage-block-muted {
		background: #f9f9f9
	}
	.iconimage-block-primary {
		background: #00448b
	}
	.iconimage-block-secondary {
		background: #222
	}
	.iconimage-block-default+.iconimage-block-default,
	.iconimage-block-muted+.iconimage-block-muted,
	.iconimage-block-primary+.iconimage-block-primary,
	.iconimage-block-secondary+.iconimage-block-secondary {
		padding-top: 0
	}
	.iconimage-article:after,
	.iconimage-article:before {
		content: "";
		display: table
	}
	.iconimage-article:after {
		clear: both
	}
	.iconimage-article>:last-child {
		margin-bottom: 0
	}
	.iconimage-article+.iconimage-article {
		margin-top: 25px
	}
	.iconimage-article-title {
		font-size: 36px;
		line-height: 42px;
		font-weight: 400;
		text-transform: none
	}
	.iconimage-article-title a {
		color: inherit;
		text-decoration: none
	}
	.iconimage-article-meta {
		font-size: 12px;
		line-height: 18px;
		color: #999
	}
	.iconimage-article-lead {
		color: #444;
		font-size: 18px;
		line-height: 24px;
		font-weight: 400
	}
	.iconimage-article-divider {
		margin-bottom: 25px;
		border-color: #ddd
	}
	*+.iconimage-article-divider {
		margin-top: 25px
	}
	.iconimage-article+.iconimage-article {
		padding-top: 25px;
		border-top: 1px solid #ddd
	}
	.iconimage-comment-header {
		margin-bottom: 15px;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		background: #fafafa
	}
	.iconimage-comment-header:after,
	.iconimage-comment-header:before {
		content: "";
		display: table
	}
	.iconimage-comment-header:after {
		clear: both
	}
	.iconimage-comment-avatar {
		margin-right: 15px;
		float: left
	}
	.iconimage-comment-title {
		margin: 5px 0 0 0;
		font-size: 16px;
		line-height: 22px
	}
	.iconimage-comment-meta {
		margin: 2px 0 0 0;
		font-size: 11px;
		line-height: 16px;
		color: #999
	}
	.iconimage-comment-body {
		padding-left: 10px;
		padding-right: 10px
	}
	.iconimage-comment-body>:last-child {
		margin-bottom: 0
	}
	.iconimage-comment-list {
		padding: 0;
		list-style: none
	}
	.iconimage-comment-list .iconimage-comment+ul {
		margin: 25px 0 0 0;
		list-style: none
	}
	.iconimage-comment-list .iconimage-comment+ul>li:nth-child(n+2),
	.iconimage-comment-list>li:nth-child(n+2) {
		margin-top: 25px
	}
	@media (min-width: 768px) {
		.iconimage-comment-list .iconimage-comment+ul {
			padding-left: 100px
		}
	}
	.iconimage-comment-primary .iconimage-comment-header {
		border-color: rgba(45, 112, 145, .3);
		background-color: #ebf7fd;
		color: #2d7091;
		text-shadow: 0 1px 0 #fff
	}
	.iconimage-cover-background {
		background-position: 50% 50%;
		background-size: cover;
		background-repeat: no-repeat
	}
	.iconimage-cover {
		overflow: hidden
	}
	.iconimage-cover-object {
		width: auto;
		height: auto;
		min-width: 100%;
		min-height: 100%;
		max-width: none;
		position: relative;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%)
	}
	[data-iconimage-cover] {
		position: relative;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%)
	}
	.iconimage-thumbnav {
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-ms-flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-left: -10px;
		margin-top: -10px;
		padding: 0;
		list-style: none
	}
	.iconimage-thumbnav>* {
		-ms-flex: none;
		-webkit-flex: none;
		flex: none;
		padding-left: 10px;
		margin-top: 10px
	}
	.iconimage-thumbnav:after,
	.iconimage-thumbnav:before {
		content: "";
		display: block;
		overflow: hidden
	}
	.iconimage-thumbnav:after {
		clear: both
	}
	.iconimage-thumbnav>* {
		float: left
	}
	.iconimage-thumbnav>*>* {
		display: block;
		background: #fff
	}
	.iconimage-thumbnav>*>*>img {
		opacity: .7;
		-webkit-transition: opacity .15s linear;
		transition: opacity .15s linear
	}
	.iconimage-thumbnav>*>:focus>img,
	.iconimage-thumbnav>*>:hover>img {
		opacity: 1
	}
	.iconimage-thumbnav>.iconimage-active>*>img {
		opacity: 1
	}
	.iconimage-list {
		padding: 0;
		list-style: none
	}
	.iconimage-list>li:after,
	.iconimage-list>li:before {
		content: "";
		display: table
	}
	.iconimage-list>li:after {
		clear: both
	}
	.iconimage-list>li>:last-child {
		margin-bottom: 0
	}
	.iconimage-list ul {
		margin: 0;
		padding-left: 20px;
		list-style: none
	}
	.iconimage-list-line>li:nth-child(n+2) {
		margin-top: 5px;
		padding-top: 5px;
		border-top: 1px solid #ddd
	}
	.iconimage-list-striped>li {
		padding: 5px 5px;
		border-bottom: 1px solid #ddd
	}
	.iconimage-list-striped>li:nth-of-type(odd) {
		background: #fafafa
	}
	.iconimage-list-space>li:nth-child(n+2) {
		margin-top: 10px
	}
	.iconimage-list-striped>li:first-child {
		border-top: 1px solid #ddd
	}
	@media (min-width: 768px) {
		.iconimage-description-list-horizontal {
			overflow: hidden
		}
		.iconimage-description-list-horizontal>dt {
			width: 160px;
			float: left;
			clear: both;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap
		}
		.iconimage-description-list-horizontal>dd {
			margin-left: 180px
		}
	}
	.iconimage-description-list-line>dt {
		font-weight: 400
	}
	.iconimage-description-list-line>dt:nth-child(n+2) {
		margin-top: 5px;
		padding-top: 5px;
		border-top: 1px solid #ddd
	}
	.iconimage-description-list-line>dd {
		color: #999
	}
	.iconimage-table {
		border-collapse: collapse;
		border-spacing: 0;
		width: 100%;
		margin-bottom: 15px
	}
	*+.iconimage-table {
		margin-top: 15px
	}
	.iconimage-table td,
	.iconimage-table th {
		padding: 8px 8px;
		border-bottom: 1px solid #ddd
	}
	.iconimage-table th {
		text-align: left
	}
	.iconimage-table td {
		vertical-align: top
	}
	.iconimage-table thead th {
		vertical-align: bottom
	}
	.iconimage-table caption,
	.iconimage-table tfoot {
		font-size: 12px;
		font-style: italic
	}
	.iconimage-table caption {
		text-align: left;
		color: #999
	}
	.iconimage-table tbody tr.iconimage-active {
		background: #f0f0f0
	}
	.iconimage-table-middle,
	.iconimage-table-middle td {
		vertical-align: middle!important
	}
	.iconimage-table-striped tbody tr:nth-of-type(odd) {
		background: #fafafa
	}
	.iconimage-table-condensed td {
		padding: 4px 8px
	}
	.iconimage-table-hover tbody tr:hover {
		background: #f0f0f0
	}
	.iconimage-form input,
	.iconimage-form select,
	.iconimage-form textarea {
		box-sizing: border-box;
		margin: 0;
		border-radius: 0;
		font: inherit;
		color: inherit
	}
	.iconimage-form select {
		text-transform: none
	}
	.iconimage-form optgroup {
		font: inherit;
		font-weight: 700
	}
	.iconimage-form input::-moz-focus-inner {
		border: 0;
		padding: 0
	}
	.iconimage-form input[type=checkbox],
	.iconimage-form input[type=radio] {
		padding: 0
	}
	.iconimage-form input[type=checkbox]:not(:disabled),
	.iconimage-form input[type=radio]:not(:disabled) {
		cursor: pointer
	}
	.iconimage-form input:not([type]),
	.iconimage-form input[type=text],
	.iconimage-form input[type=password],
	.iconimage-form input[type=email],
	.iconimage-form input[type=url],
	.iconimage-form input[type=search],
	.iconimage-form input[type=tel],
	.iconimage-form input[type=number],
	.iconimage-form input[type=datetime],
	.iconimage-form textarea {
		-webkit-appearance: none
	}
	.iconimage-form input[type=search]::-webkit-search-cancel-button,
	.iconimage-form input[type=search]::-webkit-search-decoration {
		-webkit-appearance: none
	}
	.iconimage-form input[type=number]::-webkit-inner-spin-button,
	.iconimage-form input[type=number]::-webkit-outer-spin-button {
		height: auto
	}
	.iconimage-form fieldset {
		border: none;
		margin: 0;
		padding: 0
	}
	.iconimage-form textarea {
		overflow: auto;
		vertical-align: top
	}
	.iconimage-form::-moz-placeholder {
		opacity: 1
	}
	.iconimage-form:invalid {
		box-shadow: none
	}
	.iconimage-form input:not([type=radio]):not([type=checkbox]),
	.iconimage-form select {
		vertical-align: middle
	}
	.iconimage-form>:last-child {
		margin-bottom: 0
	}
	.iconimage-form input:not([type]),
	.iconimage-form input[type=text],
	.iconimage-form input[type=password],
	.iconimage-form input[type=email],
	.iconimage-form input[type=url],
	.iconimage-form input[type=search],
	.iconimage-form input[type=tel],
	.iconimage-form input[type=number],
	.iconimage-form input[type=datetime],
	.iconimage-form input[type=datetime-local],
	.iconimage-form input[type=date],
	.iconimage-form input[type=month],
	.iconimage-form input[type=time],
	.iconimage-form input[type=week],
	.iconimage-form input[type=color],
	.iconimage-form select,
	.iconimage-form textarea {
		height: 30px;
		max-width: 100%;
		padding: 4px 6px;
		border: 1px solid #ddd;
		background: #fff;
		color: #444;
		-webkit-transition: all .2s linear;
		-webkit-transition-property: border, background, color, box-shadow, padding;
		transition: all .2s linear;
		transition-property: border, background, color, box-shadow, padding;
		border-radius: 4px
	}
	.iconimage-form input:not([type]):focus,
	.iconimage-form input[type=text]:focus,
	.iconimage-form input[type=password]:focus,
	.iconimage-form input[type=email]:focus,
	.iconimage-form input[type=url]:focus,
	.iconimage-form input[type=search]:focus,
	.iconimage-form input[type=tel]:focus,
	.iconimage-form input[type=number]:focus,
	.iconimage-form input[type=datetime]:focus,
	.iconimage-form input[type=datetime-local]:focus,
	.iconimage-form input[type=date]:focus,
	.iconimage-form input[type=month]:focus,
	.iconimage-form input[type=time]:focus,
	.iconimage-form input[type=week]:focus,
	.iconimage-form input[type=color]:focus,
	.iconimage-form select:focus,
	.iconimage-form textarea:focus {
		border-color: #99baca;
		outline: 0;
		background: #f5fbfe;
		color: #444
	}
	.iconimage-form input:not([type]):disabled,
	.iconimage-form input[type=text]:disabled,
	.iconimage-form input[type=password]:disabled,
	.iconimage-form input[type=email]:disabled,
	.iconimage-form input[type=url]:disabled,
	.iconimage-form input[type=search]:disabled,
	.iconimage-form input[type=tel]:disabled,
	.iconimage-form input[type=number]:disabled,
	.iconimage-form input[type=datetime]:disabled,
	.iconimage-form input[type=datetime-local]:disabled,
	.iconimage-form input[type=date]:disabled,
	.iconimage-form input[type=month]:disabled,
	.iconimage-form input[type=time]:disabled,
	.iconimage-form input[type=week]:disabled,
	.iconimage-form input[type=color]:disabled,
	.iconimage-form select:disabled,
	.iconimage-form textarea:disabled {
		border-color: #ddd;
		background-color: #fafafa;
		color: #999
	}
	.iconimage-form:-ms-input-placeholder {
		color: #999!important
	}
	.iconimage-form::-moz-placeholder {
		color: #999
	}
	.iconimage-form::-webkit-input-placeholder {
		color: #999
	}
	.iconimage-form:disabled:-ms-input-placeholder {
		color: #999!important
	}
	.iconimage-form:disabled::-moz-placeholder {
		color: #999
	}
	.iconimage-form:disabled::-webkit-input-placeholder {
		color: #999
	}
	.iconimage-form legend {
		width: 100%;
		border: 0;
		padding: 0;
		padding-bottom: 15px;
		font-size: 18px;
		line-height: 30px
	}
	.iconimage-form legend:after {
		content: "";
		display: block;
		border-bottom: 1px solid #ddd;
		width: 100%
	}
	input:not([type]).iconimage-form-small,
	input[type].iconimage-form-small,
	select.iconimage-form-small,
	textarea.iconimage-form-small {
		height: 25px;
		padding: 3px 3px;
		font-size: 12px
	}
	input:not([type]).iconimage-form-large,
	input[type].iconimage-form-large,
	select.iconimage-form-large,
	textarea.iconimage-form-large {
		height: 40px;
		padding: 8px 6px;
		font-size: 16px
	}
	.iconimage-form select[multiple],
	.iconimage-form select[size],
	.iconimage-form textarea {
		height: auto
	}
	.iconimage-form-danger {
		border-color: #dc8d99!important;
		background: #fff7f8!important;
		color: #d85030!important
	}
	.iconimage-form-success {
		border-color: #8ec73b!important;
		background: #fafff2!important;
		color: #659f13!important
	}
	.iconimage-form-blank {
		border-color: transparent!important;
		border-style: dashed!important;
		background: 0 0!important
	}
	.iconimage-form-blank:focus {
		border-color: #ddd!important
	}
	input.iconimage-form-width-mini {
		width: 40px
	}
	select.iconimage-form-width-mini {
		width: 65px
	}
	.iconimage-form-width-small {
		width: 130px
	}
	.iconimage-form-width-medium {
		width: 200px
	}
	.iconimage-form-width-large {
		width: 500px
	}
	.iconimage-form-row:after,
	.iconimage-form-row:before {
		content: "";
		display: table
	}
	.iconimage-form-row:after {
		clear: both
	}
	.iconimage-form-row+.iconimage-form-row {
		margin-top: 15px
	}
	.iconimage-form-help-inline {
		display: inline-block;
		margin: 0 0 0 10px
	}
	.iconimage-form-help-block {
		margin: 5px 0 0 0
	}
	.iconimage-form-controls>:first-child {
		margin-top: 0
	}
	.iconimage-form-controls>:last-child {
		margin-bottom: 0
	}
	.iconimage-form-controls-condensed {
		margin: 5px 0
	}
	.iconimage-form-stacked .iconimage-form-label {
		display: block;
		margin-bottom: 5px;
		font-weight: 700
	}
	@media (max-width: 959px) {
		.iconimage-form-horizontal .iconimage-form-label {
			display: block;
			margin-bottom: 5px;
			font-weight: 700
		}
	}
	@media (min-width: 960px) {
		.iconimage-form-horizontal .iconimage-form-label {
			width: 200px;
			margin-top: 5px;
			float: left
		}
		.iconimage-form-horizontal .iconimage-form-controls {
			margin-left: 215px
		}
		.iconimage-form-horizontal .iconimage-form-controls-text {
			padding-top: 5px
		}
	}
	.iconimage-form-icon {
		display: inline-block;
		position: relative;
		max-width: 100%
	}
	.iconimage-form-icon>[class*=iconimage-icon-] {
		position: absolute;
		top: 50%;
		width: 30px;
		margin-top: -7px;
		font-size: 14px;
		color: #999;
		text-align: center;
		pointer-events: none
	}
	.iconimage-form-icon:not(.iconimage-form-icon-flip)>input {
		padding-left: 30px!important
	}
	.iconimage-form-icon-flip>[class*=iconimage-icon-] {
		right: 0
	}
	.iconimage-form-icon-flip>input {
		padding-right: 30px!important
	}
	.iconimage-button::-moz-focus-inner {
		border: 0;
		padding: 0
	}
	.iconimage-button {
		-webkit-appearance: none;
		margin: 0;
		border: none;
		overflow: visible;
		font: inherit;
		color: #444;
		text-transform: none;
		display: inline-block;
		box-sizing: border-box;
		padding: 0 12px;
		background: #f5f5f5;
		vertical-align: middle;
		line-height: 28px;
		min-height: 30px;
		font-size: 1rem;
		text-decoration: none;
		text-align: center;
		border: 1px solid rgba(0, 0, 0, .06);
		border-radius: 4px;
		text-shadow: 0 1px 0 #fff
	}
	.iconimage-button:not(:disabled) {
		cursor: pointer
	}
	.iconimage-button:focus,
	.iconimage-button:hover {
		background-color: #fafafa;
		color: #444;
		outline: 0;
		text-decoration: none;
		border-color: rgba(0, 0, 0, .16)
	}
	.iconimage-button.iconimage-active,
	.iconimage-button:active {
		background-color: #eee;
		color: #444
	}
	.iconimage-button-primary {
		background-color: #00448b;
		color: #fff
	}
	.iconimage-button-primary:focus,
	.iconimage-button-primary:hover {
		background-color: #005dae;
		color: #fff
	}
	.iconimage-button-primary.iconimage-active,
	.iconimage-button-primary:active {
		background-color: #00448b;
		color: #fff
	}
	.iconimage-button-success {
		background-color: #8cc14c;
		color: #fff
	}
	.iconimage-button-success:focus,
	.iconimage-button-success:hover {
		background-color: #8ec73b;
		color: #fff
	}
	.iconimage-button-success.iconimage-active,
	.iconimage-button-success:active {
		background-color: #72ae41;
		color: #fff
	}
	.iconimage-button-danger {
		background-color: #da314b;
		color: #fff
	}
	.iconimage-button-danger:focus,
	.iconimage-button-danger:hover {
		background-color: #e4354f;
		color: #fff
	}
	.iconimage-button-danger.iconimage-active,
	.iconimage-button-danger:active {
		background-color: #c91032;
		color: #fff
	}
	.iconimage-button:disabled {
		background-color: #fafafa;
		color: #999;
		border-color: rgba(0, 0, 0, .06);
		box-shadow: none;
		text-shadow: 0 1px 0 #fff
	}
	.iconimage-button-link,
	.iconimage-button-link.iconimage-active,
	.iconimage-button-link:active,
	.iconimage-button-link:disabled,
	.iconimage-button-link:focus,
	.iconimage-button-link:hover {
		border-color: transparent;
		background: 0 0;
		box-shadow: none;
		text-shadow: none
	}
	.iconimage-button-link {
		color: #00448b
	}
	.iconimage-button-link.iconimage-active,
	.iconimage-button-link:active,
	.iconimage-button-link:focus,
	.iconimage-button-link:hover {
		color: #059;
		text-decoration: underline
	}
	.iconimage-button-link:disabled {
		color: #999
	}
	.iconimage-button-link:focus {
		outline: 1px dotted
	}
	.iconimage-button-mini {
		min-height: 20px;
		padding: 0 6px;
		line-height: 18px;
		font-size: 11px
	}
	.iconimage-button-small {
		min-height: 25px;
		padding: 0 10px;
		line-height: 23px;
		font-size: 12px
	}
	.iconimage-button-large {
		min-height: 40px;
		padding: 0 15px;
		line-height: 38px;
		font-size: 16px;
		border-radius: 5px
	}
	.iconimage-button-group {
		display: inline-block;
		vertical-align: middle;
		position: relative;
		font-size: 0;
		white-space: nowrap
	}
	.iconimage-button-group>* {
		display: inline-block
	}
	.iconimage-button-group .iconimage-button {
		vertical-align: top
	}
	.iconimage-button-dropdown {
		display: inline-block;
		vertical-align: middle;
		position: relative
	}
	.iconimage-button-danger,
	.iconimage-button-primary,
	.iconimage-button-success {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, .05);
		text-shadow: 0 -1px 0 rgba(0, 0, 0, .1)
	}
	.iconimage-button-danger:focus,
	.iconimage-button-danger:hover,
	.iconimage-button-primary:focus,
	.iconimage-button-primary:hover,
	.iconimage-button-success:focus,
	.iconimage-button-success:hover {
		border-color: rgba(0, 0, 0, .21)
	}
	.iconimage-button-group>.iconimage-button:not(:first-child):not(:last-child),
	.iconimage-button-group>div:not(:first-child):not(:last-child) .iconimage-button {
		border-left-color: rgba(0, 0, 0, .1);
		border-right-color: rgba(0, 0, 0, .1);
		border-radius: 0
	}
	.iconimage-button-group>.iconimage-button:first-child,
	.iconimage-button-group>div:first-child .iconimage-button {
		border-right-color: rgba(0, 0, 0, .1);
		border-top-right-radius: 0;
		border-bottom-right-radius: 0
	}
	.iconimage-button-group>.iconimage-button:last-child,
	.iconimage-button-group>div:last-child .iconimage-button {
		border-left-color: rgba(0, 0, 0, .1);
		border-top-left-radius: 0;
		border-bottom-left-radius: 0
	}
	.iconimage-button-group>.iconimage-button:nth-child(n+2),
	.iconimage-button-group>div:nth-child(n+2) .iconimage-button {
		margin-left: -1px
	}
	.iconimage-button-group .iconimage-button.iconimage-active,
	.iconimage-button-group .iconimage-button:active,
	.iconimage-button-group .iconimage-button:hover {
		position: relative
	}
.iconimage-icon-small {
	font-size: 150%;
	vertical-align: -10%
}
.iconimage-icon-medium {
	font-size: 200%;
	vertical-align: -16%
}
.iconimage-icon-large {
	font-size: 250%;
	vertical-align: -22%
}
.iconimage-icon-justify {
	width: 1em;
	text-align: center
}
.iconimage-icon-spin {
	display: inline-block;
	-webkit-animation: iconimage-rotate 2s infinite linear;
	animation: iconimage-rotate 2s infinite linear
}
.iconimage-icon-hover {
	color: #999
}
.iconimage-icon-hover:hover {
	color: #444
}
.iconimage-icon-button {
	box-sizing: border-box;
	display: inline-block;
	width: 35px;
	height: 35px;
	border-radius: 100%;
	background: #f5f5f5;
	line-height: 35px;
	color: #444;
	font-size: 18px;
	text-align: center;
	border: 1px solid #e7e7e7;
	text-shadow: 0 1px 0 #fff
}
.iconimage-icon-button:focus,
.iconimage-icon-button:hover {
	background-color: #fafafa;
	color: #444;
	outline: 0;
	border-color: #d3d3d3
}
.iconimage-icon-button:active {
	background-color: #eee;
	color: #444
}
.iconimage-close::-moz-focus-inner {
	border: 0;
	padding: 0
}
.iconimage-close {
	-webkit-appearance: none;
	margin: 0;
	border: none;
	overflow: visible;
	font: inherit;
	color: inherit;
	text-transform: none;
	padding: 0;
	background: 0 0;
	display: inline-block;
	box-sizing: content-box;
	width: 20px;
	line-height: 20px;
	text-align: center;
	vertical-align: middle;
	opacity: .3
}
.iconimage-close:focus,
.iconimage-close:hover {
	opacity: .5;
	outline: 0;
	color: inherit;
	text-decoration: none;
	cursor: pointer
}
.iconimage-close-alt {
	padding: 2px;
	border-radius: 50%;
	background: #fff;
	opacity: 1;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, .1), 0 0 6px rgba(0, 0, 0, .3)
}
.iconimage-close-alt:focus,
.iconimage-close-alt:hover {
	opacity: 1
}
.iconimage-close-alt:after {
	opacity: .5
}
.iconimage-close-alt:focus:after,
.iconimage-close-alt:hover:after {
	opacity: .8
}
.iconimage-badge {
	display: inline-block;
	padding: 0 5px;
	background: #00448b;
	font-size: 10px;
	font-weight: 700;
	line-height: 14px;
	color: #fff;
	text-align: center;
	vertical-align: middle;
	text-transform: none;
	border: 1px solid rgba(0, 0, 0, .06);
	border-radius: 2px;
	text-shadow: 0 1px 0 rgba(0, 0, 0, .1)
}
a.iconimage-badge:hover {
	color: #fff
}
.iconimage-badge-notification {
	box-sizing: border-box;
	min-width: 18px;
	border-radius: 500px;
	font-size: 12px;
	line-height: 18px
}
.iconimage-badge-success {
	background-color: #8cc14c
}
.iconimage-badge-warning {
	background-color: #faa732
}
.iconimage-badge-danger {
	background-color: #da314b
}
.iconimage-alert {
	margin-bottom: 15px;
	padding: 10px;
	background: #ebf7fd;
	color: #2d7091;
	border: 1px solid rgba(45, 112, 145, .3);
	border-radius: 4px;
	text-shadow: 0 1px 0 #fff
}
*+.iconimage-alert {
	margin-top: 15px
}
.iconimage-alert>:last-child {
	margin-bottom: 0
}
.iconimage-alert h1,
.iconimage-alert h2,
.iconimage-alert h3,
.iconimage-alert h4,
.iconimage-alert h5,
.iconimage-alert h6 {
	color: inherit
}
.iconimage-alert>.iconimage-close:first-child {
	float: right
}
.iconimage-alert>.iconimage-close:first-child+* {
	margin-top: 0
}
.iconimage-alert-success {
	background: #f2fae3;
	color: #659f13;
	border-color: rgba(101, 159, 19, .3)
}
.iconimage-alert-warning {
	background: #fffceb;
	color: #e28327;
	border-color: rgba(226, 131, 39, .3)
}
.iconimage-alert-danger {
	background: #fff1f0;
	color: #d85030;
	border-color: rgba(216, 80, 48, .3)
}
.iconimage-alert-large {
	padding: 20px
}
.iconimage-alert-large>.iconimage-close:first-child {
	margin: -10px -10px 0 0
}
.iconimage-thumbnail {
	display: inline-block;
	max-width: 100%;
	box-sizing: border-box;
	margin: 0;
	padding: 4px;
	border: 1px solid #ddd;
	background: #fff;
	border-radius: 4px
}
a.iconimage-thumbnail:focus,
a.iconimage-thumbnail:hover {
	border-color: #aaa;
	background-color: #fff;
	text-decoration: none;
	outline: 0
}
.iconimage-thumbnail-caption {
	padding-top: 4px;
	text-align: center;
	color: #444
}
.iconimage-thumbnail-mini {
	width: 150px
}
.iconimage-thumbnail-small {
	width: 200px
}
.iconimage-thumbnail-medium {
	width: 300px
}
.iconimage-thumbnail-large {
	width: 400px
}
.iconimage-thumbnail-expand,
.iconimage-thumbnail-expand>img {
	width: 100%
}
[class*=iconimage-column-] {
	-webkit-column-gap: 25px;
	-moz-column-gap: 25px;
	column-gap: 25px
}
.iconimage-column-1-2 {
	-webkit-column-count: 2;
	-moz-column-count: 2;
	column-count: 2
}
.iconimage-column-1-3 {
	-webkit-column-count: 3;
	-moz-column-count: 3;
	column-count: 3
}
.iconimage-column-1-4 {
	-webkit-column-count: 4;
	-moz-column-count: 4;
	column-count: 4
}
.iconimage-column-1-5 {
	-webkit-column-count: 5;
	-moz-column-count: 5;
	column-count: 5
}
.iconimage-column-1-6 {
	-webkit-column-count: 6;
	-moz-column-count: 6;
	column-count: 6
}
@media (min-width: 480px) {
	.iconimage-column-small-1-2 {
		-webkit-column-count: 2;
		-moz-column-count: 2;
		column-count: 2
	}
	.iconimage-column-small-1-3 {
		-webkit-column-count: 3;
		-moz-column-count: 3;
		column-count: 3
	}
	.iconimage-column-small-1-4 {
		-webkit-column-count: 4;
		-moz-column-count: 4;
		column-count: 4
	}
	.iconimage-column-small-1-5 {
		-webkit-column-count: 5;
		-moz-column-count: 5;
		column-count: 5
	}
	.iconimage-column-small-1-6 {
		-webkit-column-count: 6;
		-moz-column-count: 6;
		column-count: 6
	}
}
@media (min-width: 768px) {
	.iconimage-column-medium-1-2 {
		-webkit-column-count: 2;
		-moz-column-count: 2;
		column-count: 2
	}
	.iconimage-column-medium-1-3 {
		-webkit-column-count: 3;
		-moz-column-count: 3;
		column-count: 3
	}
	.iconimage-column-medium-1-4 {
		-webkit-column-count: 4;
		-moz-column-count: 4;
		column-count: 4
	}
	.iconimage-column-medium-1-5 {
		-webkit-column-count: 5;
		-moz-column-count: 5;
		column-count: 5
	}
	.iconimage-column-medium-1-6 {
		-webkit-column-count: 6;
		-moz-column-count: 6;
		column-count: 6
	}
}
@media (min-width: 960px) {
	.iconimage-column-large-1-2 {
		-webkit-column-count: 2;
		-moz-column-count: 2;
		column-count: 2
	}
	.iconimage-column-large-1-3 {
		-webkit-column-count: 3;
		-moz-column-count: 3;
		column-count: 3
	}
	.iconimage-column-large-1-4 {
		-webkit-column-count: 4;
		-moz-column-count: 4;
		column-count: 4
	}
	.iconimage-column-large-1-5 {
		-webkit-column-count: 5;
		-moz-column-count: 5;
		column-count: 5
	}
	.iconimage-column-large-1-6 {
		-webkit-column-count: 6;
		-moz-column-count: 6;
		column-count: 6
	}
}
@media (min-width: 1220px) {
	.iconimage-column-xlarge-1-2 {
		-webkit-column-count: 2;
		-moz-column-count: 2;
		column-count: 2
	}
	.iconimage-column-xlarge-1-3 {
		-webkit-column-count: 3;
		-moz-column-count: 3;
		column-count: 3
	}
	.iconimage-column-xlarge-1-4 {
		-webkit-column-count: 4;
		-moz-column-count: 4;
		column-count: 4
	}
	.iconimage-column-xlarge-1-5 {
		-webkit-column-count: 5;
		-moz-column-count: 5;
		column-count: 5
	}
	.iconimage-column-xlarge-1-6 {
		-webkit-column-count: 6;
		-moz-column-count: 6;
		column-count: 6
	}
}
.iconimage-text-capitalize {
	text-transform: capitalize!important
}
.iconimage-text-lowercase {
	text-transform: lowercase!important
}
.iconimage-text-uppercase {
	text-transform: uppercase!important
}
.iconimage-container {
	box-sizing: border-box;
	max-width: 980px;
	padding: 0 25px
}
@media (min-width: 1220px) {
	.iconimage-container {
		max-width: 1200px;
		padding: 0 35px
	}
}
.iconimage-container:after,
.iconimage-container:before {
	content: "";
	display: table
}
.iconimage-container:after {
	clear: both
}
.iconimage-container-center {
	margin-left: auto;
	margin-right: auto
}
.iconimage-clearfix:before {
	content: "";
	display: table-cell
}
.iconimage-clearfix:after {
	content: "";
	display: table;
	clear: both
}
.iconimage-nbfc {
	overflow: hidden
}
.iconimage-nbfc-alt {
	display: table-cell;
	width: 10000px
}
.iconimage-float-left {
	float: left
}
.iconimage-float-right {
	float: right
}
[class*=iconimage-float-] {
	max-width: 100%
}
[class*=iconimage-align-] {
	display: block;
	margin-bottom: 15px
}
.iconimage-align-left {
	margin-right: 15px;
	float: left
}
.iconimage-align-right {
	margin-left: 15px;
	float: right
}
@media (min-width: 768px) {
	.iconimage-align-medium-left {
		margin-right: 15px;
		float: left
	}
	.iconimage-align-medium-right {
		margin-left: 15px;
		float: right
	}
}
.iconimage-align-center {
	margin-left: auto;
	margin-right: auto
}
.iconimage-vertical-align {
	font-size: 0
}
.iconimage-vertical-align:before {
	content: '';
	display: inline-block;
	height: 100%;
	vertical-align: middle
}
.iconimage-vertical-align-bottom,
.iconimage-vertical-align-middle {
	display: inline-block;
	max-width: 100%;
	font-size: 1rem
}
.iconimage-vertical-align-middle {
	vertical-align: middle
}
.iconimage-vertical-align-bottom {
	vertical-align: bottom
}
[class*=iconimage-height] {
	box-sizing: border-box
}
.iconimage-height-1-1 {
	height: 100%
}
.iconimage-height-viewport {
	height: 100vh;
	min-height: 600px
}
.iconimage-responsive-height,
.iconimage-responsive-width {
	box-sizing: border-box
}
.iconimage-responsive-width {
	max-width: 100%!important;
	height: auto
}
.iconimage-responsive-height {
	max-height: 100%;
	width: auto
}
.iconimage-margin {
	margin-bottom: 15px
}
*+.iconimage-margin {
	margin-top: 15px
}
.iconimage-margin-top {
	margin-top: 15px!important
}
.iconimage-margin-bottom {
	margin-bottom: 15px!important
}
.iconimage-margin-left {
	margin-left: 15px!important
}
.iconimage-margin-right {
	margin-right: 15px!important
}
.iconimage-margin-large {
	margin-bottom: 50px
}
*+.iconimage-margin-large {
	margin-top: 50px
}
.iconimage-margin-large-top {
	margin-top: 50px!important
}
.iconimage-margin-large-bottom {
	margin-bottom: 50px!important
}
.iconimage-margin-large-left {
	margin-left: 50px!important
}
.iconimage-margin-large-right {
	margin-right: 50px!important
}
.iconimage-margin-small {
	margin-bottom: 5px
}
*+.iconimage-margin-small {
	margin-top: 5px
}
.iconimage-margin-small-top {
	margin-top: 5px!important
}
.iconimage-margin-small-bottom {
	margin-bottom: 5px!important
}
.iconimage-margin-small-left {
	margin-left: 5px!important
}
.iconimage-margin-small-right {
	margin-right: 5px!important
}
.iconimage-margin-remove {
	margin: 0!important
}
.iconimage-margin-top-remove {
	margin-top: 0!important
}
.iconimage-margin-bottom-remove {
	margin-bottom: 0!important
}
.iconimage-padding-remove {
	padding: 0!important
}
.iconimage-padding-top-remove {
	padding-top: 0!important
}
.iconimage-padding-bottom-remove {
	padding-bottom: 0!important
}
.iconimage-padding-vertical-remove {
	padding-top: 0!important;
	padding-bottom: 0!important
}
.iconimage-border-circle {
	border-radius: 50%
}
.iconimage-border-rounded {
	border-radius: 5px
}
.iconimage-heading-large {
	font-size: 36px;
	line-height: 42px
}
@media (min-width: 768px) {
	.iconimage-heading-large {
		font-size: 52px;
		line-height: 64px
	}
}
.iconimage-link-muted,
.iconimage-link-muted a {
	color: #444
}
.iconimage-link-muted a:hover,
.iconimage-link-muted:hover {
	color: #444
}
.iconimage-link-reset,
.iconimage-link-reset a,
.iconimage-link-reset a:focus,
.iconimage-link-reset a:hover,
.iconimage-link-reset:focus,
.iconimage-link-reset:hover {
	color: inherit;
	text-decoration: none
}
.iconimage-scrollable-text {
	height: 300px;
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
	resize: both
}
.iconimage-scrollable-box {
	box-sizing: border-box;
	height: 170px;
	padding: 10px;
	border: 1px solid #ddd;
	overflow: auto;
	-webkit-overflow-scrolling: touch;
	resize: both;
	border-radius: 3px
}
.iconimage-scrollable-box>:last-child {
	margin-bottom: 0
}
.iconimage-overflow-hidden {
	overflow: hidden
}
.iconimage-overflow-container {
	overflow: auto;
	-webkit-overflow-scrolling: touch
}
.iconimage-overflow-container>:last-child {
	margin-bottom: 0
}
.iconimage-position-absolute,
[class*=iconimage-position-top],
[class*=iconimage-position-bottom] {
	position: absolute!important
}
.iconimage-position-top {
	top: 0;
	left: 0;
	right: 0
}
.iconimage-position-bottom {
	bottom: 0;
	left: 0;
	right: 0
}
.iconimage-position-top-left {
	top: 0;
	left: 0
}
.iconimage-position-top-right {
	top: 0;
	right: 0
}
.iconimage-position-bottom-left {
	bottom: 0;
	left: 0
}
.iconimage-position-bottom-right {
	bottom: 0;
	right: 0
}
.iconimage-position-cover {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0
}
.iconimage-position-relative {
	position: relative!important
}
.iconimage-position-z-index {
	z-index: 1
}
.iconimage-display-block {
	display: block!important
}
.iconimage-display-inline {
	display: inline!important
}
.iconimage-display-inline-block {
	display: inline-block!important;
	max-width: 100%
}
@media (min-width: 960px) {
	.iconimage-visible-small {
		display: none!important
	}
	.iconimage-visible-medium {
		display: none!important
	}
	.iconimage-hidden-large {
		display: none!important
	}
}
@media (min-width: 768px) and (max-width: 959px) {
	.iconimage-visible-small {
		display: none!important
	}
	.iconimage-visible-large {
		display: none!important
	}
	.iconimage-hidden-medium {
		display: none!important
	}
}
@media (max-width: 767px) {
	.iconimage-visible-medium {
		display: none!important
	}
	.iconimage-visible-large {
		display: none!important
	}
	.iconimage-hidden-small {
		display: none!important
	}
}
.iconimage-hidden {
	display: none!important;
	visibility: hidden!important
}
.iconimage-invisible {
	visibility: hidden!important
}
.iconimage-visible-hover:hover .iconimage-hidden,
.iconimage-visible-hover:hover .iconimage-invisible {
	display: block!important;
	visibility: visible!important
}
.iconimage-visible-hover-inline:hover .iconimage-hidden,
.iconimage-visible-hover-inline:hover .iconimage-invisible {
	display: inline-block!important;
	visibility: visible!important
}
.iconimage-notouch .iconimage-hidden-notouch,
.iconimage-touch .iconimage-hidden-touch {
	display: none!important
}
.iconimage-flex {
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex
}
.iconimage-flex-inline {
	display: -ms-inline-flexbox;
	display: -webkit-inline-flex;
	display: inline-flex
}
.iconimage-flex-inline>*,
.iconimage-flex>* {
	-ms-flex-negative: 1
}
.iconimage-flex-top {
	-ms-flex-align: start;
	-webkit-align-items: flex-start;
	align-items: flex-start
}
.iconimage-flex-middle {
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center
}
.iconimage-flex-bottom {
	-ms-flex-align: end;
	-webkit-align-items: flex-end;
	align-items: flex-end
}
.iconimage-flex-center {
	-ms-flex-pack: center;
	-webkit-justify-content: center;
	justify-content: center
}
.iconimage-flex-right {
	-ms-flex-pack: end;
	-webkit-justify-content: flex-end;
	justify-content: flex-end
}
.iconimage-flex-space-between {
	-ms-flex-pack: justify;
	-webkit-justify-content: space-between;
	justify-content: space-between
}
.iconimage-flex-space-around {
	-ms-flex-pack: distribute;
	-webkit-justify-content: space-around;
	justify-content: space-around
}
.iconimage-flex-row-reverse {
	-ms-flex-direction: row-reverse;
	-webkit-flex-direction: row-reverse;
	flex-direction: row-reverse
}
.iconimage-flex-column {
	-ms-flex-direction: column;
	-webkit-flex-direction: column;
	flex-direction: column
}
.iconimage-flex-column-reverse {
	-ms-flex-direction: column-reverse;
	-webkit-flex-direction: column-reverse;
	flex-direction: column-reverse
}
.iconimage-flex-nowrap {
	-ms-flex-wrap: nowrap;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap
}
.iconimage-flex-wrap {
	-ms-flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	flex-wrap: wrap
}
.iconimage-flex-wrap-reverse {
	-ms-flex-wrap: wrap-reverse;
	-webkit-flex-wrap: wrap-reverse;
	flex-wrap: wrap-reverse
}
.iconimage-flex-wrap-top {
	-ms-flex-line-pack: start;
	-webkit-align-content: flex-start;
	align-content: flex-start
}
.iconimage-flex-wrap-middle {
	-ms-flex-line-pack: center;
	-webkit-align-content: center;
	align-content: center
}
.iconimage-flex-wrap-bottom {
	-ms-flex-line-pack: end;
	-webkit-align-content: flex-end;
	align-content: flex-end
}
.iconimage-flex-wrap-space-between {
	-ms-flex-line-pack: justify;
	-webkit-align-content: space-between;
	align-content: space-between
}
.iconimage-flex-wrap-space-around {
	-ms-flex-line-pack: distribute;
	-webkit-align-content: space-around;
	align-content: space-around
}
.iconimage-flex-order-first {
	-ms-flex-order: -1;
	-webkit-order: -1;
	order: -1
}
.iconimage-flex-order-last {
	-ms-flex-order: 99;
	-webkit-order: 99;
	order: 99
}
@media (min-width: 480px) {
	.iconimage-flex-order-first-small {
		-ms-flex-order: -1;
		-webkit-order: -1;
		order: -1
	}
	.iconimage-flex-order-last-small {
		-ms-flex-order: 99;
		-webkit-order: 99;
		order: 99
	}
}
@media (min-width: 768px) {
	.iconimage-flex-order-first-medium {
		-ms-flex-order: -1;
		-webkit-order: -1;
		order: -1
	}
	.iconimage-flex-order-last-medium {
		-ms-flex-order: 99;
		-webkit-order: 99;
		order: 99
	}
}
@media (min-width: 960px) {
	.iconimage-flex-order-first-large {
		-ms-flex-order: -1;
		-webkit-order: -1;
		order: -1
	}
	.iconimage-flex-order-last-large {
		-ms-flex-order: 99;
		-webkit-order: 99;
		order: 99
	}
}
@media (min-width: 1220px) {
	.iconimage-flex-order-first-xlarge {
		-ms-flex-order: -1;
		-webkit-order: -1;
		order: -1
	}
	.iconimage-flex-order-last-xlarge {
		-ms-flex-order: 99;
		-webkit-order: 99;
		order: 99
	}
}
.iconimage-flex-item-none {
	-ms-flex: none;
	-webkit-flex: none;
	flex: none
}
.iconimage-flex-item-auto {
	-ms-flex: auto;
	-webkit-flex: auto;
	flex: auto;
	-ms-flex-negative: 1
}
.iconimage-flex-item-1 {
	-ms-flex: 1;
	-webkit-flex: 1;
	flex: 1
}
.iconimage-contrast {
	color: #fff
}
.iconimage-contrast .iconimage-link,
.iconimage-contrast a:not([class]) {
	color: rgba(255, 255, 255, .7);
	text-decoration: none
}
.iconimage-contrast .iconimage-link:hover,
.iconimage-contrast a:not([class]):hover {
	color: #fff;
	text-decoration: underline
}
.iconimage-contrast:not(pre)>code,
.iconimage-contrast:not(pre)>kbd,
.iconimage-contrast:not(pre)>samp {
	color: #fff;
	border-color: rgba(255, 255, 255, .2);
	background: rgba(255, 255, 255, .1)
}
.iconimage-contrast em {
	color: #fff
}
.iconimage-contrast h1,
.iconimage-contrast h2,
.iconimage-contrast h3,
.iconimage-contrast h4,
.iconimage-contrast h5,
.iconimage-contrast h6 {
	color: #fff
}
.iconimage-contrast hr {
	border-top-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-nav li>a,
.iconimage-contrast .iconimage-nav li>a:hover {
	text-decoration: none
}
.iconimage-contrast .iconimage-nav-side>li>a {
	color: #fff
}
.iconimage-contrast .iconimage-nav-side>li>a:focus,
.iconimage-contrast .iconimage-nav-side>li>a:hover {
	background: rgba(255, 255, 255, .1);
	color: #fff;
	text-shadow: none
}
.iconimage-contrast .iconimage-nav-side>li.iconimage-active>a {
	background: #fff;
	color: #444;
	text-shadow: none
}
.iconimage-contrast .iconimage-nav-side .iconimage-nav-header {
	color: #fff
}
.iconimage-contrast .iconimage-nav-side .iconimage-nav-divider {
	border-top-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-nav-side ul a {
	color: rgba(255, 255, 255, .7)
}
.iconimage-contrast .iconimage-nav-side ul a:hover {
	color: #fff
}
.iconimage-contrast .iconimage-subnav>*>a {
	color: rgba(255, 255, 255, .7);
	text-decoration: none
}
.iconimage-contrast .iconimage-subnav>*>a:focus,
.iconimage-contrast .iconimage-subnav>*>a:hover {
	color: #fff;
	text-decoration: none
}
.iconimage-contrast .iconimage-subnav>.iconimage-active>a {
	color: #fff
}
.iconimage-contrast .iconimage-subnav-line>:nth-child(n+2):before {
	border-left-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-subnav-pill>*>a:focus,
.iconimage-contrast .iconimage-subnav-pill>*>a:hover {
	background: rgba(255, 255, 255, .7);
	color: #444;
	text-decoration: none
}
.iconimage-contrast .iconimage-subnav-pill>.iconimage-active>a {
	background: #fff;
	color: #444
}
.iconimage-contrast .iconimage-tab {
	border-bottom-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-tab>li>a {
	border-color: transparent;
	color: rgba(255, 255, 255, .7);
	text-shadow: none
}
.iconimage-contrast .iconimage-tab>li.iconimage-open>a,
.iconimage-contrast .iconimage-tab>li>a:focus,
.iconimage-contrast .iconimage-tab>li>a:hover {
	border-color: rgba(255, 255, 255, .7);
	background: rgba(255, 255, 255, .7);
	color: #444;
	text-decoration: none
}
.iconimage-contrast .iconimage-tab>li.iconimage-active>a {
	border-color: rgba(255, 255, 255, .2);
	border-bottom-color: transparent;
	background: #fff;
	color: #444
}
.iconimage-contrast .iconimage-tab-center {
	border-bottom-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-tab-grid:before {
	border-top-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-list-line>li:nth-child(n+2) {
	border-top-color: rgba(255, 255, 255, .2)
}
.iconimage-contrast .iconimage-form input:not([type]),
.iconimage-contrast .iconimage-form input[type=text],
.iconimage-contrast .iconimage-form input[type=password],
.iconimage-contrast .iconimage-form input[type=email],
.iconimage-contrast .iconimage-form input[type=url],
.iconimage-contrast .iconimage-form input[type=search],
.iconimage-contrast .iconimage-form input[type=tel],
.iconimage-contrast .iconimage-form input[type=number],
.iconimage-contrast .iconimage-form input[type=datetime],
.iconimage-contrast .iconimage-form input[type=datetime-local],
.iconimage-contrast .iconimage-form input[type=date],
.iconimage-contrast .iconimage-form input[type=month],
.iconimage-contrast .iconimage-form input[type=time],
.iconimage-contrast .iconimage-form input[type=week],
.iconimage-contrast .iconimage-form input[type=color],
.iconimage-contrast .iconimage-form select,
.iconimage-contrast .iconimage-form textarea {
	border-color: rgba(255, 255, 255, .8);
	background: rgba(255, 255, 255, .8);
	color: #444;
	background-clip: padding-box
}
.iconimage-contrast .iconimage-form input:not([type]):focus,
.iconimage-contrast .iconimage-form input[type=text]:focus,
.iconimage-contrast .iconimage-form input[type=password]:focus,
.iconimage-contrast .iconimage-form input[type=email]:focus,
.iconimage-contrast .iconimage-form input[type=url]:focus,
.iconimage-contrast .iconimage-form input[type=search]:focus,
.iconimage-contrast .iconimage-form input[type=tel]:focus,
.iconimage-contrast .iconimage-form input[type=number]:focus,
.iconimage-contrast .iconimage-form input[type=datetime]:focus,
.iconimage-contrast .iconimage-form input[type=datetime-local]:focus,
.iconimage-contrast .iconimage-form input[type=date]:focus,
.iconimage-contrast .iconimage-form input[type=month]:focus,
.iconimage-contrast .iconimage-form input[type=time]:focus,
.iconimage-contrast .iconimage-form input[type=week]:focus,
.iconimage-contrast .iconimage-form input[type=color]:focus,
.iconimage-contrast .iconimage-form select:focus,
.iconimage-contrast .iconimage-form textarea:focus {
	border-color: #fff;
	background: #fff;
	color: #444
}
.iconimage-contrast .iconimage-form:-ms-input-placeholder {
	color: rgba(68, 68, 68, .7)!important
}
.iconimage-contrast .iconimage-form::-moz-placeholder {
	color: rgba(68, 68, 68, .7)
}
.iconimage-contrast .iconimage-form::-webkit-input-placeholder {
	color: rgba(68, 68, 68, .7)
}
.iconimage-contrast .iconimage-button {
	color: #444;
	background: #fff;
	border-color: transparent
}
.iconimage-contrast .iconimage-button:focus,
.iconimage-contrast .iconimage-button:hover {
	background-color: rgba(255, 255, 255, .8);
	color: #444;
	border-color: transparent
}
.iconimage-contrast .iconimage-button.iconimage-active,
.iconimage-contrast .iconimage-button:active {
	background-color: rgba(255, 255, 255, .7);
	color: #444
}
.iconimage-contrast .iconimage-button-primary {
	background-color: #00448b;
	color: #fff
}
.iconimage-contrast .iconimage-button-primary:focus,
.iconimage-contrast .iconimage-button-primary:hover {
	background-color: #005dae;
	color: #fff
}
.iconimage-contrast .iconimage-button-primary.iconimage-active,
.iconimage-contrast .iconimage-button-primary:active {
	background-color: #00448b;
	color: #fff
}
.iconimage-contrast .iconimage-icon-hover {
	color: rgba(255, 255, 255, .7)
}
.iconimage-contrast .iconimage-icon-hover:hover {
	color: #fff
}
.iconimage-contrast .iconimage-icon-button {
	background: #fff;
	color: #444;
	border-color: transparent
}
.iconimage-contrast .iconimage-icon-button:focus,
.iconimage-contrast .iconimage-icon-button:hover {
	background-color: rgba(255, 255, 255, .8);
	color: #444;
	border-color: transparent
}
.iconimage-contrast .iconimage-icon-button:active {
	background-color: rgba(255, 255, 255, .7);
	color: #444
}
.iconimage-contrast .iconimage-text-muted {
	color: rgba(255, 255, 255, .6)!important
}
.iconimage-contrast .iconimage-text-primary {
	color: #2d7091!important
}
</style>